/* script */














































































































































































































import { tl } from '../languages';

const __vue_script__ = {
	name: 'panel-timeline',
	data() {return {
		size: 300,
		length: 10,
		timeline_height: 100,
		animation_length: 0,
		scroll_left: 0,
		scroll_top: 0,
		head_width: Blockbench.isMobile ? 108 : Interface.data.timeline_head,
		timecodes: [],
		animators: Timeline.animators,
		markers: [],
		custom_range: Timeline.custom_range,
		waveforms: Timeline.waveforms,
		focus_channel: null,
		playhead: Timeline.time,
		timestamp: '0',
		framenumber: '0',

		graph_editor_open: false,
		graph_editor_channel: 'rotation',
		graph_editor_axis: 'x',
		graph_offset: 200,
		graph_size: 200,
		show_other_graphs: true,
		include_other_graphs: true,
		show_zero_line: true,
		show_all_handles: !Settings.get('only_selected_bezier_handles'),
		loop_graphs: [''],

		onion_skin_selectable: BarItems.animation_onion_skin.value,
		onion_skin_time: 0,

		channels: StateMemory.timeline_channels,

		samplingScale: 4.0,

		keyframeHoverUuid: "",
		bezierHandleHover: {
			keyUuid: "",
			side: ""
		},
		keyframeIcons: { // There has to be a better way to type these characters, but this is the best I found for now - Aza
			linear: {
			  	default: "",
			  	discontinuous:  "",
				molang: "",
				discontinuous_molang: ""
			},
			bezier: {
			 	default: "",
				discontinuous: "",
			 	molang: "",
				discontinuous_molang: ""
			},
			smooth: {
			  	default: "",
			  	molang: ""
			},
			step: {
			  	default: "",
			  	discontinuous: "",
				molang: "",
				discontinuous_molang: ""
			},
			hidden: {
			  	default: "",
				discontinuous: "",
				molang: ""
			}
		}
	}},
	watch: {
		size() {this.updateTimecodes()},
		length() {this.updateTimecodes()},
		scroll_left() {this.updateTimecodes()},
	},
	computed: {
		graph_editor_animator() {
			return this.animators.find(animator => animator.selected && animator instanceof BoneAnimator);
		},
		zero_line() {
			let height = this.graph_offset;
			return `M0 ${height} L10000 ${height}`
		},
		one_line() {
			let height = this.graph_offset - this.graph_size;
			return `M0 ${height} L10000 ${height}`
		},
		rulers() {
			let lines = [];
			let values = [0];

			let interval_options = [1, 2, 4, 8, 10, 20, 25, 50, 100, 200, 250, 400, 500];
			let estimate = 100 / Timeline.vue.graph_size;
			if (estimate > 500) return values;
			let interval = Math.snapToValues(estimate, interval_options);
			let box_height = Timeline.vue.$refs.timeline_body.clientHeight;

			for (let i = 1; i < 20; i += 1) {
				let value = i * interval;
				let keep_going = false;
				if (this.graph_offset - value * this.graph_size > 0) {
					values.push(value);
					keep_going = true;
				}
				if (this.graph_offset + value * this.graph_size < box_height) {
					values.push(i * -interval);
					keep_going = true;
				}
				if (!keep_going) break;
			}

			values.forEach(value => {
				let height = this.graph_offset - this.graph_size * value;
				lines.push({
					position: height,
					label: Math.round(value),
					path: `M0 ${height} L10000 ${height}`
				});
			})
			return lines;
		},
		graphs() {
			let ba = this.graph_editor_animator;
			if (!ba || !ba[this.graph_editor_channel] || !ba[this.graph_editor_channel].length) {
				this.loop_graphs.empty();
				return [];
			}
			let original_time = Timeline.time;
			let step = 2;
			let clientWidth = this.$refs.timeline_body ? this.$refs.timeline_body.clientWidth : 400;
			let clientHeight = this.$refs.timeline_body ? this.$refs.timeline_body.clientHeight : 400;
			let keyframes = ba[this.graph_editor_channel];
			let points = [];
			let loop_points = [];

			let min = this.show_zero_line ? -1 : Timeline.graph_editor_limit,
				max = this.show_zero_line ? 1 : -Timeline.graph_editor_limit;

			for (let time = Math.clamp(this.scroll_left - 9, 0, Infinity); time < (clientWidth + this.scroll_left - this.head_width); time += step) {
				Timeline.time = time / this.size;

				let snap_kf = keyframes.find(kf => Timeline.time <= kf.time && Timeline.time > kf.time - step / this.size );
				if (snap_kf) {
					Timeline.time = snap_kf.time;
				}
				Animator.resetLastValues();
				let values = [
					(this.show_other_graphs || this.graph_editor_axis === 'x') ? ba.interpolate(this.graph_editor_channel, false, 'x') : 0,
					(this.show_other_graphs || this.graph_editor_axis === 'y') ? ba.interpolate(this.graph_editor_channel, false, 'y') : 0,
					(this.show_other_graphs || this.graph_editor_axis === 'z') ? ba.interpolate(this.graph_editor_channel, false, 'z') : 0
				];
				let value = values[this.graph_editor_axis_number];
				if (snap_kf) snap_kf.display_value = value;
				
				if (Timeline.time > Animation.selected.length && Animation.selected.length && Animation.selected.loop === 'loop') {
					if (points.length && !loop_points.length) loop_points.push(points.last())
					loop_points.push(values);
				} else {
					points.push(values);
					if (this.show_other_graphs && this.include_other_graphs) {
						min = Math.min(min, ...values);
						max = Math.max(max, ...values);
					} else {
						min = Math.min(min, value);
						max = Math.max(max, value);
					}
				}
			}
			keyframes.forEach(kf => {
				if (kf.interpolation === 'bezier') {
					min = Math.min(min, kf.display_value + kf.bezier_left_value[this.graph_editor_axis_number]);
					max = Math.max(max, kf.display_value + kf.bezier_left_value[this.graph_editor_axis_number]);
					min = Math.min(min, kf.display_value + kf.bezier_right_value[this.graph_editor_axis_number]);
					max = Math.max(max, kf.display_value + kf.bezier_right_value[this.graph_editor_axis_number]);
				}
			})
			
			Timeline.time = original_time;

			let padding = 16;
			let min_size = 2.4;
			let unit_size = Math.clamp(max-min, min_size, Timeline.graph_editor_limit);
			this.graph_size = (clientHeight - 2*padding) / unit_size;
			let blend = Math.clamp(1 - (max-min) / min_size, 0, 1)
			this.graph_offset = clientHeight - padding + (this.graph_size * (min - unit_size/2 * blend ) );

			let graphs = this.show_other_graphs ? ['', '', ''] : [''];
			points.forEach((values, i) => {
				let command = i == 0 ? 'M' : 'L';
				if (this.show_other_graphs) {
					values.forEach((value, axis) => {
						graphs[axis] += `${command}${i*step} ${this.graph_offset - value * this.graph_size} `;
					})
				} else {
					graphs[0] += `${command}${i*step} ${this.graph_offset - values[this.graph_editor_axis_number] * this.graph_size} `;
				}
			})

			this.loop_graphs.empty();
			if (loop_points.length) {
				if (this.show_other_graphs) {
					this.loop_graphs.push('', '', '');
				} else {
					this.loop_graphs.push('');
				}
				loop_points.forEach((values, i) => {
					let command = i == 0 ? 'M' : 'L';
					i = i + points.length - 1;
					if (this.show_other_graphs) {
						values.forEach((value, axis) => {
							this.loop_graphs[axis] += `${command}${i*step} ${this.graph_offset - value * this.graph_size} `;
						})
					} else {
						this.loop_graphs[0] += `${command}${i*step} ${this.graph_offset - values[this.graph_editor_axis_number] * this.graph_size} `;
					}
				})
			}
			
			this.refreshTimelineCanvas();
			return graphs;
		},
		graph_editor_axis_number() {
			return getAxisNumber(this.graph_editor_axis)
		}
	},
	methods: {
		tl,
		setGraphEditorAxis(axis) {
			this.graph_editor_axis = axis; 
			this.refreshTimelineCanvas();
		},
		clearTimelineCanvas() {
			let bodyCanvas = $('#timeline_body_keyframe_canvas').get(0);
			let context = bodyCanvas.getContext("2d");
			context.clearRect(0, 0, bodyCanvas.width, bodyCanvas.height);
		},
		shouldCullKeyframeOnGraph(keyframe) {
			if (!this.graph_editor_open) return false;
			let body = $('#timeline_body').get(0);
			let timelineStyle = window.getComputedStyle(body);
			let rectHeight = body.clientHeight;
			let rectWidth = body.clientWidth - this.head_width;
			let scrollOffsetY = body.scrollTop;
			let scrollOffsetX = body.scrollLeft;

			let keyRadius = timelineStyle.getPropertyValue("--keyframe-radius").trim();
			let keyHoveredRadius = timelineStyle.getPropertyValue("--keyframe-radius-hover").trim();
			let handleDiameter = timelineStyle.getPropertyValue("--keyframe-bezier-handle-diameter").trim();
			let keyHoveredHalfradius = keyHoveredRadius / 2.0;
			let keyHalfRadius = keyRadius / 2.0;
			let handleRadius = handleDiameter / 2.0;
			let size = this.size;
			let graphSize = this.graph_size;
			let graphOffset = this.graph_offset;
			let graphAxis = this.graph_editor_axis;
			let hoveredKeyframe = this.keyframeHoverUuid;
			let hoveredBezierHandle = this.bezierHandleHover;

			let timeStamp = keyframe.time;
			let isHovered = (hoveredKeyframe === keyframe.uuid);
			let anyHandleHovered = (hoveredBezierHandle.keyUuid === keyframe.uuid);
			let keyHalfScale = (isHovered || anyHandleHovered) ? keyHoveredHalfradius : keyHalfRadius;

			// Get keyframe X and Y without the text box offset
			let keyX = ((timeStamp * size) + keyHalfRadius - scrollOffsetX);
			let keyY = (graphOffset - (keyframe.display_value * graphSize) - scrollOffsetY);
			
			// Get keyframe X and Y with the text box offset
			let posX = (timeStamp * size) - (keyHalfScale - keyHoveredHalfradius) - scrollOffsetX;
			let posY = graphOffset - (keyframe.display_value * graphSize) - keyHalfScale - scrollOffsetY;
			
			// Handle position info
			let axis = getAxisNumber(graphAxis);
			let leftOffsetX = (keyframe[`bezier_left_time`][axis] * size) + keyX;
			let rightOffsetX = (keyframe[`bezier_right_time`][axis] * size) + keyX;
			let leftOffsetY = (-keyframe[`bezier_left_value`][axis] * graphSize) + keyY;
			let rightOffsetY = (-keyframe[`bezier_right_value`][axis] * graphSize) + keyY;

			// Checks
			let leftHandleOutOnLeft = (leftOffsetX < (handleRadius / 2.0));
			let leftHandleOutOnTop = (leftOffsetY < (handleRadius / 2.0));
			let leftHandleOutOnRight = (leftOffsetX > rectWidth + (handleRadius / 2.0));
			let leftHandleOutOnBottom = (leftOffsetY > rectHeight + (handleRadius / 2.0));
			let rightHandleOutOnLeft = (rightOffsetX < (handleRadius / 2.0));
			let rightHandleOutOnTop = (rightOffsetY < (handleRadius / 2.0));
			let rightHandleOutOnRight = (rightOffsetX > rectWidth + (handleRadius / 2.0));
			let rightHandleOutOnBottom = (rightOffsetY > rectHeight + (handleRadius / 2.0));
			let keyOutOnLeft = (posX < -keyHalfScale);
			let keyOutOnTop = (posY < -keyHalfScale);
			let keyOutOnRight = (posX > rectWidth - keyHalfScale);
			let keyOutOnBottom = (posY > rectHeight - keyHalfScale);

			let allOutOnLeft = keyOutOnLeft && leftHandleOutOnLeft && rightHandleOutOnLeft;
			let allOutOnTop = keyOutOnTop && leftHandleOutOnTop && rightHandleOutOnTop;
			let allOutOnRight = keyOutOnRight && leftHandleOutOnRight && rightHandleOutOnRight;
			let allOutOnBottom = keyOutOnBottom && leftHandleOutOnBottom && rightHandleOutOnBottom;
			if (allOutOnLeft || allOutOnRight || allOutOnTop || allOutOnBottom) return true;
			return false;
		},
		refreshTimelineCanvas() {
			if (!this._isMounted) return;
			if (!Animation.selected) { this.clearTimelineCanvas(); return; }
			if (!this.animators.length || (this.graph_editor_open && !this.graph_editor_animator)) { this.clearTimelineCanvas(); return; }

			// Store stuff, yk
			let size = this.size;
			let scale = this.samplingScale;
			let hoveredKeyframe = this.keyframeHoverUuid; 
			let hoveredBezierHandle = this.bezierHandleHover; 
			let icons = this.keyframeIcons;
			let isGraph = this.graph_editor_open;
			let graphOffset = this.graph_offset;
			let graphSize = this.graph_size;
			let graphShowAllHandles = this.show_all_handles;
			let graphAxis = this.graph_editor_axis;

			// Get required elements, stop if canvas is missing, we can't draw on nothing.
			let body = $('#timeline_body').get(0);
			let bodyCanvas = $('#timeline_body_keyframe_canvas').get(0);
			let bodyBackdrop = $('#timeline_body_keyframe_backdrop').get(0);
			if (!bodyCanvas) return;

			// Collect body style & scroll data
			let timelineStyle = window.getComputedStyle(body);
			let keyRadius = timelineStyle.getPropertyValue("--keyframe-radius").trim();
			let keyHoveredRadius = timelineStyle.getPropertyValue("--keyframe-radius-hover").trim();
			let keyGraphRadius = timelineStyle.getPropertyValue("--keyframe-graph-radius").trim();
			let keyGraphHoveredRadius = timelineStyle.getPropertyValue("--keyframe-graph-radius-hover").trim();
			let keyHiddenRadius = timelineStyle.getPropertyValue("--keyframe-radius-hidden").trim();
			let handleDiameter = timelineStyle.getPropertyValue("--keyframe-bezier-handle-diameter").trim();
			let handleStrokeWidth = timelineStyle.getPropertyValue("--keyframe-bezier-stroke-width").trim();
			let keyframeColor = timelineStyle.getPropertyValue("--color-keyframe").trim();
			let keyframeSelectedColor = timelineStyle.getPropertyValue("--color-keyframe-selected").trim();
			let keyframeHoveredColor = timelineStyle.getPropertyValue("--color-keyframe-hovered").trim();
			let keyframeCollapsedColor = timelineStyle.getPropertyValue("--color-keyframe-collapsed").trim();;
			let bezierHandleColor = timelineStyle.getPropertyValue("--color-keyframe-bezier-handle-dot").trim();
			let bezierHandleLineColor = timelineStyle.getPropertyValue("--color-keyframe-bezier-handle-line").trim();
			let keyHalfRadius = keyRadius / 2.0;
			let keyHoveredHalfradius = keyHoveredRadius / 2.0;
			let keyGraphHalfRadius = keyGraphRadius / 2.0;
			let keyGraphHoveredHalfradius = keyGraphHoveredRadius / 2.0;
			let keyHiddenHalfRadius = keyHiddenRadius / 2.0;
			let scrollOffsetY = body.scrollTop;
			let scrollOffsetX = body.scrollLeft;

			// Collect data & setup variables used for rendering only
			let context = bodyCanvas.getContext("2d");

			// Over-sample keyframe view, to avoid cut-off lines and odd blurs
			let rectHeight = body.clientHeight;
			let rectWidth = body.clientWidth - this.head_width;
			bodyCanvas.height = rectHeight * scale;
			bodyCanvas.width = rectWidth * scale;
			bodyCanvas.style.height = `${rectHeight}px`;
			bodyCanvas.style.width = `${rectWidth}px`;
			bodyBackdrop.style.translate = `-${rectWidth}px 0`;

			function drawKeyframe(keyframe, settings = { offset: 0, isCollapsed: false, isGraph: false }) {
				let radius = settings.isGraph ? keyGraphRadius : keyRadius;
				let halfRadius = settings.isGraph ? keyGraphHalfRadius : keyHalfRadius;
				let hoverRadius = settings.isGraph ? keyGraphHoveredRadius : keyHoveredRadius;
				let hoverHalfRadius = settings.isGraph ? keyGraphHoveredHalfradius : keyHoveredHalfradius;

				let isHovered = (hoveredKeyframe === keyframe.uuid);
				let anyHandleHovered = (hoveredBezierHandle.keyUuid === keyframe.uuid);
				let keyHalfScale = settings.isCollapsed ? keyHiddenHalfRadius : ((isHovered || anyHandleHovered) ? hoverHalfRadius : halfRadius);
				let timeStamp = keyframe.time;
				let posX = (timeStamp * size) - (keyHalfScale - hoverHalfRadius) - scrollOffsetX;
				let posY = settings.offset - keyHalfScale;
				
				if (settings.isGraph) {
					posY = graphOffset - (keyframe.display_value * graphSize) - keyHalfScale - scrollOffsetY;

					// Stop early if keyframe is out of frame
					if (Timeline.vue.shouldCullKeyframeOnGraph(keyframe)) return;
				}
				// Stop early if keyframe is out of frame horizontally
				else if (((posX < -keyHalfScale) || (posX > rectWidth - keyHalfScale))) return;

				// Set color & scale for hovering and selection
				let isSelected = keyframe.selected;
				let keyScale = radius * scale; // Over-sampled scale of keyframe
				let markerColor = Timeline.vue.getColor(keyframe.color, isHovered || anyHandleHovered);
				let color = (markerColor || keyframeColor);
				if (isSelected) {
					// Selection color
					color = keyframeSelectedColor;
				}
				if (isHovered || anyHandleHovered) {
					// Hovering scale & color (unless selected, then we use selection color) 
					color = isSelected ? keyframeSelectedColor : (markerColor || keyframeHoveredColor);
					keyScale = hoverRadius * scale;
				}
				if (settings.isCollapsed) {
					// Hidden scale & color 
					color = keyframeCollapsedColor
					keyScale = keyHiddenRadius * scale;
				};

				function pickIcon(iconData, continuousOnly = false) {
					let data = iconData;
					if (settings.isCollapsed) data = icons.hidden;

					if (continuousOnly) {
						if (isMolang) return data.molang;
						else return data.default;
					}

					if (isMolang && !isContinuous && !settings.isCollapsed) return data.discontinuous_molang;
					else if (isMolang) return data.molang;
					else if (!isContinuous) return data.discontinuous;
					else return data.default;
				} 

				let txtPosition = [(posX * scale), (posY * scale)];
				let icon = "";
				let isMolang = keyframe.has_expressions;
				let isContinuous = keyframe.data_points?.length == 1 || false;
				switch (keyframe.interpolation) {
					case "step": { 
						icon = pickIcon(icons.step);
						break; 
					}
					case "bezier": { 
						icon = pickIcon(settings.isGraph ? icons.linear : icons.bezier);
						break; 
					}
					case "catmullrom": { 
						icon = pickIcon(icons.smooth, true);
						break; 
					}
					default: { 
						icon = pickIcon(icons.linear);
						break; 
					}
				}

				if (settings.isGraph) {
					let displayHandles = (keyframe.interpolation == "bezier") && (graphShowAllHandles || keyframe.selected);

					if (displayHandles) {
						// Get keyframe X and Y without the text box offset
						let keyX = (timeStamp * size) + halfRadius - scrollOffsetX;
						let keyY = graphOffset - (keyframe.display_value * graphSize) - scrollOffsetY;

						// Handle position info
						let axis = getAxisNumber(graphAxis);
						let leftOffsetX = (keyframe[`bezier_left_time`][axis] * size) + keyX;
						let rightOffsetX = (keyframe[`bezier_right_time`][axis] * size) + keyX;
						let leftOffsetY = (-keyframe[`bezier_left_value`][axis] * graphSize) + keyY;
						let rightOffsetY = (-keyframe[`bezier_right_value`][axis] * graphSize) + keyY;
						let handleRadius = handleDiameter / 2.0;

						// Hover data
						let canBeHovered = hoveredBezierHandle.keyUuid === keyframe.uuid;
						let isLeftHovered = hoveredBezierHandle.side === "left" && canBeHovered;
						let isRightHovered = hoveredBezierHandle.side === "right" && canBeHovered;

						context.lineWidth = handleStrokeWidth * scale;
						
						// Left bezier
						context.strokeStyle = (isLeftHovered || isHovered) ? keyframeSelectedColor : bezierHandleLineColor;
						context.beginPath(); // Handle line start
						context.moveTo(keyX * scale, keyY * scale);
						context.lineTo(leftOffsetX * scale, leftOffsetY * scale);
						context.stroke();
						context.closePath();
						context.strokeStyle = (isLeftHovered || isHovered) ? keyframeSelectedColor : keyframeColor;
						context.fillStyle = bezierHandleColor;
						context.beginPath(); // Handle dot start
						context.arc(leftOffsetX * scale, leftOffsetY * scale, handleRadius * scale, 0, 2 * Math.PI);
						context.fill();
						context.stroke();
						context.closePath();

						// Right bezier
						context.strokeStyle = (isRightHovered || isHovered) ? keyframeSelectedColor : bezierHandleLineColor;
						context.beginPath(); // Handle line start
						context.moveTo(keyX * scale, keyY * scale);
						context.lineTo(rightOffsetX * scale, rightOffsetY * scale);
						context.stroke();
						context.closePath();
						context.strokeStyle = (isRightHovered || isHovered) ? keyframeSelectedColor : keyframeColor;
						context.fillStyle = bezierHandleColor;
						context.beginPath(); // Handle dot start
						context.arc(rightOffsetX * scale, rightOffsetY * scale, handleRadius * scale, 0, 2 * Math.PI);
						context.fill();
						context.stroke();
						context.closePath();
					}
				}
				
				context.font = `${keyScale}px icomoon`;
				context.fillStyle = color;
				context.textBaseline  = "top"; // Top as if it were images, starting at (0, 0) (left, top)
				context.fillText(icon, txtPosition[0], txtPosition[1]);
			}

			// re-draw keyframes.
			this.clearTimelineCanvas();
			if (isGraph) {
				let keyframes = this.graph_editor_animator[this.graph_editor_channel];
				for (let keyframe of keyframes) {
					drawKeyframe(keyframe, { isGraph: true });
				}
			}
			else {
				let channelHeight = timelineStyle.getPropertyValue("--timeline-channel-height").trim();
				let channelHalfHeight = channelHeight / 2.0;
				let heightAccumulator = 0;

				for (let i = 0; i < this.animators.length; i++) {
					let animator = this.animators[i];
					let channelKeys = Object.keys(animator.channels);
					let animatorY = channelHeight * heightAccumulator - scrollOffsetY;
					heightAccumulator++;

					for (let j = 0; j < channelKeys.length; j++) {
						let channel = channelKeys[j];
						let channelOptions = animator.channels[channel];

						// Stop early if channel should be hidden
						let channelExists = this.channels[channel] != false;
						let isConditionMet = Condition(channelOptions.condition, animator);
						let canShow = (!this.channels.hide_empty || animator[channel].length);
						let isExpanded = animator.expanded && channelExists && canShow
						if (!(isExpanded || isConditionMet)) continue;

						// Get our remaining data
						let channelY = channelHeight * heightAccumulator - scrollOffsetY;
						if (!isExpanded) channelY = animatorY;
						else if (isConditionMet) heightAccumulator++; // Add to total channel height stack if this channel is able to display

						// Stop early if channel is out of frame vertically
						if (channelY < -channelHalfHeight) continue;
						if (channelY > rectHeight - channelHalfHeight) break;

						let keyframes = animator[channel];
						for (let keyframe of keyframes) {
							drawKeyframe(keyframe, { offset: channelY + channelHalfHeight, isCollapsed: !isExpanded });
						}
					}
				}
			}
		},
		tryGetKeyframeClosestToMouse(event) {
			let body = $('#timeline_body').get(0);
			let bodyCanvas = $('#timeline_body_keyframe_canvas').get(0);
			let timelineStyle = window.getComputedStyle(body);
			let keyRadius = timelineStyle.getPropertyValue("--keyframe-radius").trim();
			let keyGraphRadius = timelineStyle.getPropertyValue("--keyframe-graph-radius").trim();
			let channelHeight = timelineStyle.getPropertyValue("--timeline-channel-height").trim();

			// Mouse position
    		let rect = bodyCanvas.getBoundingClientRect();
		    let x = event.pageX - rect.left;
		    let y = event.pageY - rect.top;
			let mouseVec = [x, y];

			// Dom info
			let size = this.size;
			let graphSize = this.graph_size;
			let channelHalfHeight = channelHeight / 2.0;
			let keyHalfRadius = keyRadius / 2.0;
			let keyGraphHalfRadius = keyGraphRadius / 2.0;
			let rectHeight = body.clientHeight;
			let rectWidth = body.clientWidth - this.head_width;
			let scrollOffsetY = body.scrollTop;
			let scrollOffsetX = body.scrollLeft;

			// Find closest keyframe to mouse
			let shortestDist = Infinity;
			let shortestUuid = "";
			let shortestHandle = "";
			if (this.graph_editor_open) {
				if (!this.graph_editor_animator) return;

				let keyframes = this.graph_editor_animator[this.graph_editor_channel];
				for (let keyframe of keyframes) {
					// Key position
					let posX = (keyframe.time * size) + keyGraphHalfRadius - scrollOffsetX;
					let posY = this.graph_offset - (keyframe.display_value * graphSize) - channelHalfHeight - scrollOffsetY;
				
					// Stop early if keyframe is out of frame
					if (this.shouldCullKeyframeOnGraph(keyframe)) continue;

					// Handle positions
					let axis = getAxisNumber(this.graph_editor_axis);
					let leftOffsetX = keyframe[`bezier_left_time`][axis] * size;
					let leftOffsetY = -keyframe[`bezier_left_value`][axis] * graphSize;
					let rightOffsetX = keyframe[`bezier_right_time`][axis] * size;
					let rightOffsetY = -keyframe[`bezier_right_value`][axis] * graphSize;

					if (keyframe.interpolation === "bezier") {
						let leftHandleVec = [leftOffsetX, leftOffsetY].V2_add([posX, posY]);
						let rightHandleVec = [rightOffsetX, rightOffsetY].V2_add([posX, posY]);
						let distanceToLeft = [...mouseVec].V2_subtract(leftHandleVec).V2_toThree().length();
						let distanceToRight = [...mouseVec].V2_subtract(rightHandleVec).V2_toThree().length();

						if (distanceToLeft < shortestDist) {
							shortestDist = distanceToLeft;
							shortestUuid = keyframe.uuid;
							shortestHandle = "left";
						}
						if (distanceToRight < shortestDist) {
							shortestDist = distanceToRight;
							shortestUuid = keyframe.uuid;
							shortestHandle = "right";
						}
					}

					let keyframeVec = [posX, posY].V2_add([keyGraphHalfRadius, keyGraphHalfRadius]);
					let distanceToKey = [...mouseVec].V2_subtract(keyframeVec).V2_toThree().length();
					if (distanceToKey < shortestDist) {
						shortestDist = distanceToKey;
						shortestUuid = keyframe.uuid;
						shortestHandle = "";
					}
				}
			}
			else {
				let heightAccumulator = 0;
				for (let i = 0; i < this.animators.length; i++) {
					let animator = this.animators[i];
					let channelKeys = Object.keys(animator.channels);
					heightAccumulator++;

					for (let j = 0; j < channelKeys.length; j++) {
						let channel = channelKeys[j];
						let channelOptions = animator.channels[channel];

						// Stop early if channel should be hidden
						let isExpanded = animator.expanded;
						let channelExists = this.channels[channel] != false;
						let isConditionMet = Condition(channelOptions.condition, animator);
						let canShow = (!this.channels.hide_empty || animator[channel].length);
						if (!(isExpanded && channelExists && isConditionMet && canShow)) continue; // This channel is not displayed atm, so we can stop.

						// Get our remaining data
						let channelY = channelHeight * heightAccumulator - scrollOffsetY;
						heightAccumulator++;

						// Stop early if channel is out of frame vertically
						if (channelY < -channelHalfHeight) continue;
						if (channelY > rectHeight - channelHalfHeight) break;

						let keyframes = animator[channel];
						for (let keyframe of keyframes) {
							let posX = (keyframe.time * size) - scrollOffsetX;
							let posY = channelY + channelHalfHeight - keyHalfRadius;

							// Stop early if keyframe is out of frame horizontally
							if ((posX < -keyHalfRadius) || (posX > rectWidth - keyHalfRadius)) continue;

							let keyframeVec = [posX, posY].V2_add([keyHalfRadius, keyHalfRadius / 4.0]); // unsure why I divided by 4 here, but it works
							let distance = [...mouseVec].V2_subtract(keyframeVec).V2_toThree().length();
							if (distance < shortestDist) {
								shortestDist = distance;
								shortestUuid = keyframe.uuid;
							}
						}
					}
				}
			}

			// Check if our closest keyframe is within the selection radius before we return it
			let closestKeyframe = Timeline.keyframes.find(keyframe => keyframe.uuid === shortestUuid);
			let trueRadius = this.graph_editor_open ? keyGraphRadius : keyRadius;
			if (shortestDist < trueRadius) {
				if (shortestHandle !== "") {
					return {
						target: closestKeyframe,
						handle: shortestHandle,
						type: "bezier_handle"
					};
				}

				return {
					target: closestKeyframe,
					type: "keyframe"
				};
			}
			
			return { type: "fail" };
			// console.log(`[${[x, y]}], ${shortestDist}, ${shortestUuid}`);
		},
		getKeyframeFromUuid(uuid) {
			if (uuid === "") return false;

			for (let animator of this.animators) {
				for (let channel of Object.keys(animator.channels)) {
					for (let keyframe of animator[channel]) {
						if (keyframe.uuid === uuid) return keyframe;
					}
				}
			}

			return false;
		},
		clickKeyframeOnCanvas(event) {
			let keyframe = this.getKeyframeFromUuid(this.keyframeHoverUuid);
			if (!keyframe) return;
			if (Timeline.selector.selecting) return;
			keyframe.clickSelect(event);
			this.refreshTimelineCanvas();
		},
		callPlayHeadToKeyframeOnCanvas(event) {
			let keyframe = this.getKeyframeFromUuid(this.keyframeHoverUuid);
			if (!keyframe) return;
			keyframe.callPlayhead();
		},
		dragOnCanvas(event) {
			let keyframe = this.getKeyframeFromUuid(this.keyframeHoverUuid);
			if (!keyframe) {
				if (this.bezierHandleHover.keyUuid !== "") {
					keyframe = this.getKeyframeFromUuid(this.bezierHandleHover.keyUuid);
					event.stopPropagation();
					this.dragBezierHandle(keyframe, this.bezierHandleHover.side, event);
				}
				return;
			}
			event.stopPropagation();
			this.dragKeyframes(keyframe, event);
		},
		openKeyframeContextMenuOnCanvas(event) {
			let keyframe = this.getKeyframeFromUuid(this.keyframeHoverUuid);
			if (!keyframe) {
				this.openContextMenu(event);
				return;
			}
			keyframe.showContextMenu(event);
		},
		hoverOnCanvas(event) {
			if (Timeline.selector.selecting) return;
			let result = this.tryGetKeyframeClosestToMouse(event);
			if (!result) return;

			switch (result.type) {
				case "keyframe": {
					if (!result.target) break;
					if (result.target.uuid === this.keyframeHoverUuid) break;

					// Make sure no handle is accidentally hovered
					if (this.bezierHandleHover.keyUuid !== "") {
						this.bezierHandleHover.keyUuid = "";
						this.bezierHandleHover.side = "";
					}

					this.keyframeHoverUuid = result.target.uuid;
					this.refreshTimelineCanvas();
					break;
				}
				case "bezier_handle": {
					if (!result.target) break;
					if (result.target.uuid === this.bezierHandleHover.keyUuid) break;
					
					// Make sure no keyframe is accidentally hovered
					if (this.keyframeHoverUuid !== "") {
						this.keyframeHoverUuid = "";
					}

					this.bezierHandleHover.keyUuid = result.target.uuid;
					this.bezierHandleHover.side = result.handle;
					this.refreshTimelineCanvas();
					break;
					// console.log(`hitting handle on the ${result.handle} of key at ${result.target.time}`)
				}
				case "fail": {
					if (this.keyframeHoverUuid !== "" || this.bezierHandleHover.keyUuid !== "") {
						this.keyframeHoverUuid = "";
						this.bezierHandleHover.keyUuid = "";
						this.bezierHandleHover.side = "";
						this.refreshTimelineCanvas();
					}
					break;
				}
			}
		},
		clearHoveredKeyframe() {
			this.keyframeHoverUuid = "";
			this.refreshTimelineCanvas();
		},
		eventTargetToAnimator(target) {
			let target_node = target;
			let i = 0;
			while (target_node && target_node.classList && !target_node.classList.contains('animator')) {
				if (i < 3 && target_node) {
					target_node = target_node.parentNode;
					i++;
				} else {
					return [];
				}
			}
			return [this.animators.find(animator => animator.uuid == target_node.attributes.uuid.value), target_node];
		},
		updateTimecodes() {
			if (!this._isMounted) return;
			this.timecodes.empty();
			let timeline_container_width = Panels.timeline.node.clientWidth - this.head_width;
			this.length = Timeline.getMaxLength();

			var step = 1
			if (this.size < 1) {step = 1}
			else if (this.size < 20) {step = 4}
			else if (this.size < 40) {step = 2}
			else if (this.size < 100) {step = 1}
			else if (this.size < 256) {step = 0.5}
			else if (this.size < 520) {step = 0.25}
			else if (this.size < 660) {step = 0.2}
			else if (this.size < 860) {step = 0.1}
			else {step = 0.05}

			// Rounding to "FPS" to better match snapping
			if (step < 1) {
				let substep_simplification = Math.max((Math.floor(Math.sqrt(step / Timeline.getStep()))-1), 1);
				var FPS = Timeline.getStep() / substep_simplification;
				step = Math.round(step/FPS) * FPS
			}

			// Substep simplification
			let substeps = step / Timeline.getStep()
			while (substeps > 8) {
				substeps /= 2;
			}
			
			// Generate
			var i = Math.floor(this.scroll_left / this.size / step) * step;
			while (i < Math.ceil((this.scroll_left + timeline_container_width) / this.size / step) * step) {
				if (settings.timecode_frame_number.value) {
					var text = Math.round(i / Timeline.getStep());
				} else {
					var text = Math.round(i*100)/100;
				}
				this.timecodes.push({
					time: i,
					width: step,
					substeps,
					text,
				})
				i += step;
			}

			if (this.graph_editor_open) {
				this.graph_size += 1e-5;
			}
		},
		updateGraph() {
			if (this.graph_editor_open) {
				this.graph_size += 1e-7;
			}
		},
		toggleAnimator(animator) {
			animator.expanded = !animator.expanded;
			this.refreshTimelineCanvas();
		},
		removeAnimator(animator) {
			Timeline.animators.remove(animator);

			if (Timeline.animators.length ===0) {
				this.clearTimelineCanvas();
			}
		},
		toggleGlobalSpace(animator) {
			Undo.initEdit({animations: [Animation.selected]});
			animator.rotation_global = !animator.rotation_global;
			Undo.finishEdit('Toggle rotation in global space');
			Animator.preview();
		},
		selectChannel(animator, channel) {
			if (this.graph_editor_channel == channel && animator.selected) return;
			if (!animator.channels[channel].transform) return;
			Undo.initSelection();
			if (!animator.selected) animator.select();
			// Select keyframe in new channel
			if (animator[channel].length && Keyframe.selected.length > 0) {
				if (animator[channel].length == 1 && Math.epsilon(animator[channel][0].time, Timeline.time, 0.002)) {
					animator[channel][0].select();
				} else if (animator[channel].find(kf => Math.epsilon(kf.time, Keyframe.selected[0].time))) {
					let kf = animator[channel].find(kf => Math.epsilon(kf.time, Keyframe.selected[0].time, 0.002));
					kf.select();
				} else {
					let kf = animator[channel].slice().sort((a, b) => Math.abs(a.time - Timeline.time) - Math.abs(b.time - Timeline.time))[0];
					kf.select();
				}
			}
			this.graph_editor_channel = channel;
			Undo.finishSelection('Select animation channel');
		},
		getColor(index, pastel = false) {
			if (index == -1 || index == undefined) return;
			let color = markerColors[index % markerColors.length];
			return pastel ? color.pastel : color.standard;
		},
		getWaveformPoints(samples, size) {
			let height = 23;
			let points = [`0,${height}`];
			samples.forEach((sample, i) => {
				points.push(`${(i + 0.5) / Timeline.waveform_sample_rate * size},${(1 - sample) * height}`);
			})
			points.push(`${(samples.length) / Timeline.waveform_sample_rate * size},${height}`)
			return points.join(' ');
		},
		updateScroll() {
			this.scroll_left = this.$refs.timeline_body ? this.$refs.timeline_body.scrollLeft : 0;
			this.scroll_top = this.$refs.timeline_body ? this.$refs.timeline_body.scrollTop : 0;
			this.refreshTimelineCanvas();
		},
		openContextMenu(event) {
			if (event.target.nodeName == 'KEYFRAME' || event.target.parentElement.nodeName == 'KEYFRAME') return;
			if (Blockbench.hasFlag('no_context_menu')) return;
			event.preventDefault();
			Timeline.menu.open(event, event);
		},
		dragAnimator(animator, e1) {
			if (getFocusedTextInput()) return;
			if (e1.button == 1 || e1.button == 2) return;
			convertTouchEvent(e1);

			let active = false;
			let helper;
			let timeout;
			let drop_target, drop_target_node, order;
			let last_event = e1;

			function move(e2) {
				convertTouchEvent(e2);
				let offset = [
					e2.clientX - e1.clientX,
					e2.clientY - e1.clientY,
				]
				if (!active) {
					let distance = Math.sqrt(Math.pow(offset[0], 2) + Math.pow(offset[1], 2))
					if (Blockbench.isTouch) {
						if (distance > 20 && timeout) {
							clearTimeout(timeout);
							timeout = null;
						} else {
							document.getElementById('timeline_body_inner').scrollTop += last_event.clientY - e2.clientY;
						}
					} else if (distance > 6) {
						active = true;
						Undo.initSelection();
					}
				} else {
					if (e2) e2.preventDefault();
					
					if (Menu.open) Menu.open.hide();

					if (!helper) {
						helper = document.createElement('div');
						helper.id = 'animation_drag_helper';
						let icon = document.createElement('i');		icon.className = 'material-icons'; icon.innerText = 'chevron_right'; helper.append(icon);
						let span = document.createElement('span');	span.innerText = animator.name;	helper.append(span);
						document.body.append(helper);
					}
					helper.style.left = `${e2.clientX}px`;
					helper.style.top = `${e2.clientY}px`;

					// drag
					$('.drag_hover').removeClass('drag_hover');
					$('.animator[order]').attr('order', null);

					let target = document.elementFromPoint(e2.clientX, e2.clientY);
					[drop_target, drop_target_node] = eventTargetToAnimator(target);
					if (drop_target) {
						let location = e2.clientY - $(drop_target_node).offset().top;
						let half_height = drop_target_node.clientHeight/2;
						let order = location <= half_height ? -1 : 1;
						drop_target_node.setAttribute('order', order)
						drop_target_node.classList.add('drag_hover');
					}
				}
				last_event = e2;
				Timeline.vue.refreshTimelineCanvas();
			}
			function off(e2) {
				if (helper) helper.remove();
				removeEventListeners(document, 'mousemove touchmove', move);
				removeEventListeners(document, 'mouseup touchend', off);
				$('.drag_hover').removeClass('drag_hover');
				$('.animator[order]').attr('order', null);
				if (Blockbench.isTouch) clearTimeout(timeout);

				if (active && !open_menu) {
					convertTouchEvent(e2);
					let target = document.elementFromPoint(e2.clientX, e2.clientY);
					let [target_animator] = eventTargetToAnimator(target);
					if (!target_animator || target_animator == animator ) return;
					
					let index = Timeline.animators.indexOf(target_animator);
					if (index == -1) return;
					if (order == 1) index++;
					if (Timeline.animators[index] == animator) return;
					Timeline.animators.remove(animator);
					Timeline.animators.splice(index, 0, animator);
					Undo.finishSelection('Rearrange animators in timeline');
					Timeline.vue.refreshTimelineCanvas();
				}
			}

			if (Blockbench.isTouch) {
				timeout = setTimeout(() => {
					active = true;
					move(e1);
				}, 320)
			}

			addEventListeners(document, 'mousemove touchmove', move, {passive: false});
			addEventListeners(document, 'mouseup touchend', off, {passive: false});
		},
		dragKeyframes(clicked, e1) {
			if (e1.target.classList.contains('keyframe_bezier_handle')) return;
			if (e1.button > 0) return;
			convertTouchEvent(e1);
			let dragging_range;
			let dragging_restriction;
			let originalValue;
			let previousValue;
			let time_stretching;
			let values_changed;
			let is_setup = false;
			let old_bezier_values = {};
			let scope = this;

			function setup() {
				dragging_range = [Infinity, 0];
				dragging_restriction;
				originalValue;
				previousValue = 0;
				time_stretching = !Timeline.vue.graph_editor_open && (e1.ctrlOrCmd || Pressing.overrides.ctrl) && Timeline.selected.length > 1;
				values_changed = false;

				if (!clicked.selected && !e1.shiftKey && !Pressing.overrides.shift && Timeline.selected.length != 0) {
					clicked.select()
				} else if (clicked && !clicked.selected) {
					clicked.select({shiftKey: true})
				}

				Undo.initEdit({keyframes: Timeline.selected});
				Timeline.dragging_keyframes = true;

				for (var kf of Timeline.selected) {
					kf.time_before = kf.time;
					dragging_range[0] = Math.min(dragging_range[0], kf.time);
					dragging_range[1] = Math.max(dragging_range[1], kf.time);
					old_bezier_values[kf.uuid] = {
						left: kf.bezier_left_time.slice(),
						right: kf.bezier_right_time.slice(),
					}
				}

				if (Timeline.vue.graph_editor_open) {
					// Find dragging restriction
					dragging_restriction = [-Infinity, Infinity];
					let ba = scope.graph_editor_animator || 0;
					let all_keyframes = ba[scope.graph_editor_channel];
					if (all_keyframes) {

						let frst_keyframe;
						let last_keyframe;
						Timeline.selected.forEach(kf => {
							if (!frst_keyframe || frst_keyframe.time > kf.time) frst_keyframe = kf;
							if (!last_keyframe || last_keyframe.time < kf.time) last_keyframe = kf;
						})
						let prvs_keyframe;
						let next_keyframe;
						all_keyframes.forEach(kf => {
							if (kf.time < frst_keyframe.time && (!prvs_keyframe || prvs_keyframe.time < kf.time)) prvs_keyframe = kf;
							if (kf.time > last_keyframe.time && (!next_keyframe || next_keyframe.time > kf.time)) next_keyframe = kf;
						})
						if (prvs_keyframe) dragging_restriction[0] = prvs_keyframe.time;
						if (next_keyframe) dragging_restriction[1] = next_keyframe.time;
					}
				}
				is_setup = true;
			}

			function slide(e2) {
				convertTouchEvent(e2);
				e2.preventDefault();
				let offset = [
					e2.clientX - e1.clientX,
					e2.clientY - e1.clientY,
				]
				if (!is_setup) {
					if (Math.pow(offset[0], 2) + Math.pow(offset[1], 2) > 40) {
						setup();
					} else {
						return;
					}
				}
				
				// Time
				let difference = 0;
				let max, min;
				let time_factor = 1;
				if ((!e2.ctrlOrCmd && !e2.shiftKey) || time_stretching || !Timeline.vue.graph_editor_open) {
					difference = Math.clamp(offset[0] / Timeline.vue._data.size, -256, 256);
					[min, max] = dragging_range;
					
					if (time_stretching) {
						time_factor = (clicked && clicked.time_before < (min + max) / 2)
							? ((max-min-difference) / (max-min))
							: ((max-min+difference) / (max-min));
						time_factor = Math.roundTo(time_factor, 2);
					}
				}

				// Value
				let value = 0;
				let value_diff = 0;
				if (Timeline.vue.graph_editor_open) {
					value = -offset[1] / Timeline.vue.graph_size;
					var round_num = canvasGridSize(e2.shiftKey || Pressing.overrides.shift, e2.ctrlOrCmd || Pressing.overrides.ctrl);
					if (Toolbox.selected.id === 'resize_tool') {
						round_num *= 0.1;
					}
					value = Math.round(value/round_num)*round_num
					previousValue = previousValue == undefined ? value : previousValue;
					originalValue = originalValue == undefined ? value : originalValue;

					if (value !== previousValue) {
						value_diff = value - (previousValue||0);
						previousValue = value;
					}
				}	
				for (let kf of Timeline.selected) {
					if (time_stretching) {
						if (clicked && clicked.time_before < (min + max) / 2) {
							var t = max - (kf.time_before - max) * -time_factor;
						} else {
							var t = min + (kf.time_before - min) * time_factor;
						}
					} else {
						var t = kf.time_before + difference;
					}
					let old_time = kf.time;
					if (dragging_restriction) {
						let step = Timeline.getStep();
						kf.time = Timeline.snapTime(Math.clamp(t, dragging_restriction[0] + step, dragging_restriction[1] - step));
					} else {
						kf.time = Timeline.snapTime(t);
					}
					if (old_time !== kf.time) {
						values_changed = true;
					}
					if (time_stretching && kf.interpolation == 'bezier') {
						let old_bezier = old_bezier_values[kf.uuid];
						kf.bezier_left_time.V3_set(old_bezier.left).V3_multiply(time_factor);
						kf.bezier_right_time.V3_set(old_bezier.right).V3_multiply(time_factor);
					}

					if (Timeline.vue.graph_editor_open && value_diff) {
						kf.offset(Timeline.vue.graph_editor_axis, value_diff);
						values_changed = true;
					}
				}
				if (time_stretching) {
					Blockbench.setStatusBarText(Math.round(time_factor * 100) + '%');
				} else {
					let text = trimFloatNumber(Math.round(difference * Animation.selected.snapping));
					if (Timeline.vue.graph_editor_open) {
						text += ` ⨉ ${trimFloatNumber(value - originalValue)}`
					}
					Blockbench.setStatusBarText(text);
				}
				BarItems.slider_keyframe_time.update()
				Animator.showMotionTrail(null, true)
				Animator.preview()
				Timeline.vue.refreshTimelineCanvas();

			}
			function off() {
				removeEventListeners(document, 'mousemove touchmove', slide);
				removeEventListeners(document, 'mouseup touchend', off);

				if (is_setup) {
					var deleted = []
					for (var kf of Timeline.selected) {
						delete kf.time_before;
						kf.replaceOthers(deleted);
					}
					Blockbench.setStatusBarText();
					if (values_changed) {
						Animation.selected.setLength();
						if (time_stretching) {
							Undo.finishEdit('Stretch keyframes');
						} else {
							Undo.addKeyframeCasualties(deleted);
							Undo.finishEdit('Drag keyframes');
						}
					} else {
						Undo.cancelEdit();
					}
					setTimeout(() => {
						Timeline.dragging_keyframes = false;
					}, 20);

					Timeline.vue.refreshTimelineCanvas();
				}
			}
			addEventListeners(document, 'mousemove touchmove', slide, {passive: false});
			addEventListeners(document, 'mouseup touchend', off);
		},
		dragBezierHandle(clicked, side, e1) {
			if (e1.button > 0) return;
			convertTouchEvent(e1);
			let values_changed;
			let is_setup = false;
			let axis_number = getAxisNumber(this.graph_editor_axis);
			let old_values = {};
			let lock_direction;

			function setup(offset) {

				if (!clicked.selected && !e1.shiftKey && !Pressing.overrides.shift && Timeline.selected.length != 0) {
					clicked.select()
				} else if (clicked && !clicked.selected) {
					clicked.select({shiftKey: true})
				}
				lock_direction = Math.abs(offset[0]) > Math.abs(offset[1]);

				Keyframe.selected.forEach(kf => {
					if (kf.interpolation == 'bezier') {
						old_values[kf.uuid] = {
							bezier_left_time: kf.bezier_left_time.slice(),
							bezier_left_value: kf.bezier_left_value.slice(),
							bezier_right_time: kf.bezier_right_time.slice(),
							bezier_right_value: kf.bezier_right_value.slice(),
						}
					}
				})

				Undo.initEdit({keyframes: Timeline.selected});
				Timeline.dragging_keyframes = true;

				is_setup = true;
			}

			function slide(e2) {
				convertTouchEvent(e2);
				e2.preventDefault();
				let offset = [
					e2.clientX - e1.clientX,
					e2.clientY - e1.clientY,
				]
				if (!is_setup) {
					if (Math.pow(offset[0], 2) + Math.pow(offset[1], 2) > 20) {
						setup(offset);
					} else {
						return;
					}
				}
				let difference_time = Math.clamp(offset[0] / Timeline.vue._data.size, -256, 256);
				let difference_value = Math.clamp(-offset[1] / Timeline.vue.graph_size, -256, 256);
				if (e2.shiftKey || Pressing.overrides.shift) {
					if (lock_direction) {
						difference_value = 0;
					} else {
						difference_time = 0;
					}
				}
				if (e2.ctrlOrCmd || Pressing.overrides.ctrl) {
					let time_snap = Timeline.getStep();
					let val_snap = 0.25;
					difference_time = Math.round(difference_time / time_snap) * time_snap;
					difference_value = Math.round(difference_value / val_snap) * val_snap;
				}

				for (let kf of Timeline.selected) {
					if (kf.interpolation == 'bezier') {

						kf.bezier_left_time.V3_set(old_values[kf.uuid].bezier_left_time);
						kf.bezier_left_value.V3_set(old_values[kf.uuid].bezier_left_value);
						kf.bezier_right_time.V3_set(old_values[kf.uuid].bezier_right_time);
						kf.bezier_right_value.V3_set(old_values[kf.uuid].bezier_right_value);

						if (side === 'left') {
							kf.bezier_left_time[axis_number] =  Math.min(0, old_values[kf.uuid].bezier_left_time[axis_number] + difference_time);
							kf.bezier_left_value[axis_number] = old_values[kf.uuid].bezier_left_value[axis_number] + difference_value;
							if (kf.bezier_linked) {
								kf.bezier_right_time[axis_number] = -kf.bezier_left_time[axis_number];
								kf.bezier_right_value[axis_number] = -kf.bezier_left_value[axis_number];
							}
						}
						if (side === 'right') {
							kf.bezier_right_time[axis_number] =  Math.max(0, old_values[kf.uuid].bezier_right_time[axis_number] + difference_time);
							kf.bezier_right_value[axis_number] = old_values[kf.uuid].bezier_right_value[axis_number] + difference_value;
							if (kf.bezier_linked) {
								kf.bezier_left_time[axis_number] = -kf.bezier_right_time[axis_number];
								kf.bezier_left_value[axis_number] = -kf.bezier_right_value[axis_number];
							}
						}
						if (kf.uniform) {
							let off_axis_a = (axis_number+1) % 3;
							let off_axis_b = (axis_number+2) % 3;
							kf.bezier_right_time[off_axis_a] = kf.bezier_right_time[off_axis_b] = kf.bezier_right_time[axis_number];
							kf.bezier_right_value[off_axis_a] = kf.bezier_right_value[off_axis_b] = kf.bezier_right_value[axis_number];
							kf.bezier_left_time[off_axis_a] = kf.bezier_left_time[off_axis_b] = kf.bezier_left_time[axis_number];
							kf.bezier_left_value[off_axis_a] = kf.bezier_left_value[off_axis_b] = kf.bezier_left_value[axis_number];
						}
						values_changed = true;
					}
				}
				let text = `${trimFloatNumber(Math.roundTo(difference_time, 2))} ⨉ ${trimFloatNumber(Math.roundTo(difference_value, 2))}`;
				Blockbench.setStatusBarText(text);

				Timeline.vue.show_zero_line = !Timeline.vue.show_zero_line;
				Timeline.vue.show_zero_line = !Timeline.vue.show_zero_line;
				Animator.showMotionTrail(null, true)
				Animator.preview()
				Timeline.vue.refreshTimelineCanvas();
			}
			function off() {
				removeEventListeners(document, 'mousemove touchmove', slide);
				removeEventListeners(document, 'mouseup touchend', off);

				if (is_setup) {
					Blockbench.setStatusBarText();
					if (values_changed) {
						Undo.finishEdit('Adjust keyframe bezier handles');
					} else {
						Undo.cancelEdit();
					}
					setTimeout(() => {
						Timeline.dragging_keyframes = false;
					}, 20);
				}
			}
			addEventListeners(document, 'mousemove touchmove', slide, {passive: false});
			addEventListeners(document, 'mouseup touchend', off);
		},
		slideGraphAmplify(e1, anchor_side) {
			if (e1.button > 0) return;
			convertTouchEvent(e1);
			let original_values = {};
			let values_changed;
			let is_setup = false;
			let keyframes = this.graph_editor_animator[this.graph_editor_channel].filter(kf => kf.selected);
			let original_range = this.getSelectedGraphRange();
			let original_pixel_range = (original_range[1] - original_range[0]) * this.graph_size;
			let axis = this.graph_editor_axis;

			function setup() {
				Undo.initEdit({keyframes});
				values_changed = false;
				Timeline.dragging_keyframes = true;
				is_setup = true;

				for (let kf of keyframes) {
					original_values[kf.uuid] = kf.display_value || kf.get(axis);
				}
			}

			function slide(e2) {
				convertTouchEvent(e2);
				e2.preventDefault();
				let offset = e2.clientY - e1.clientY;
				if (anchor_side == 1) offset *= -1;
				if (!is_setup) {
					if (Math.abs(offset) > 4) {
						setup();
					} else {
						return;
					}
				}
				
				let value = 1 - offset / original_pixel_range;
				value = Math.round(value*100)/100;

				for (let kf of keyframes) {
					let origin = original_range[anchor_side];
					if (e2.altKey) {
						origin = Math.lerp(original_range[0], original_range[1], 0.5);
					}
					let target_value = (original_values[kf.uuid] - origin) * value + origin;
					kf.offset(axis, -kf.get(axis) + target_value);
					values_changed = true;
				}
				let text = Math.round(value * 100) + '%';
				Blockbench.setStatusBarText(text);
				Animator.showMotionTrail(null, true)
				Animator.preview()
				Timeline.vue.refreshTimelineCanvas();
			}
			function off() {
				removeEventListeners(document, 'mousemove touchmove', slide);
				removeEventListeners(document, 'mouseup touchend', off);

				if (is_setup) {
					Blockbench.setStatusBarText();
					if (values_changed) {
						Undo.finishEdit('Amplify keyframes');
					} else {
						Undo.cancelEdit();
					}
					setTimeout(() => {
						Timeline.dragging_keyframes = false;
					}, 20);
				}
			}
			addEventListeners(document, 'mousemove touchmove', slide, {passive: false});
			addEventListeners(document, 'mouseup touchend', off);
		},
		clickGraphEditor(event) {
			if (!this.show_other_graphs || !this.graph_editor_animator) return;
			let value = (this.graph_offset - event.offsetY) / this.graph_size;
			let original_time = Timeline.time;

			let tryAt = (x_coord) => {
				let time = (x_coord) / this.size;
				Timeline.time = time;

				let distances = ['x', 'y', 'z'].map(axis => {
					let axis_value = this.graph_editor_animator.interpolate(this.graph_editor_channel, false, axis);
					let diff = Math.abs(axis_value - value) * this.graph_size;
					if (diff < 12.5) {
						return {axis, diff};
					}
				}).filter(a => a);
				if (distances.length) return distances;
			}
			
			let real_x_coord = event.offsetX-8;
			let distances = tryAt(real_x_coord) || tryAt(real_x_coord + 4) || tryAt(real_x_coord - 4);

			if (distances) {
				distances.sort((a, b) => a.diff - b.diff);
				this.graph_editor_axis = distances[0].axis;
			}
			Timeline.time = original_time;
		},
		getBezierHandleStyle(keyframe, side) {
			let axis_number = getAxisNumber(this.graph_editor_axis);
			let x_offset = -keyframe[`bezier_${side}_time`][axis_number] * this.size;
			let y_offset = -keyframe[`bezier_${side}_value`][axis_number] * this.graph_size;
			let length = Math.sqrt(Math.pow(x_offset, 2) + Math.pow(y_offset, 2));
			let angle = Math.atan2(-y_offset, x_offset);
			return {
				right: x_offset + 'px',
				top: y_offset + 'px',
				'--length': Math.max(length - 6, 0) + 'px',
				'--angle': Math.radToDeg(angle) + 'deg',
			}
		},
		getSelectedGraphRange() {
			if (Keyframe.selected.length == 0 || !this.graph_editor_animator) return null;
			let keyframes = this.graph_editor_animator[this.graph_editor_channel];
			if (!keyframes || keyframes.length < 2) return null;
			let range = [Infinity, -Infinity];
			keyframes.forEach(kf => {
				if (!kf.selected) return;
				range[0] = Math.min(range[0], kf.display_value);
				range[1] = Math.max(range[1], kf.display_value);
			})
			if (range[0] == range[1]) return null;
			return range;
		},
		getNodeColor(node) {
			if (node.color >= 0) {
				return markerColors[node.color % markerColors.length].pastel;
			}
			return '';
		},
		clamp: Math.clamp,
		Condition,
		trimFloatNumber,
		getAxisLetter
	}
}

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { graph_editor: _vm.graph_editor_open },
      style: { "--timeline-height": _vm.timeline_height + "px" },
      attrs: { id: "timeline_vue" },
    },
    [
      _c("div", { attrs: { id: "timeline_header" } }, [
        _c(
          "div",
          {
            style: { width: _vm.head_width + "px" },
            attrs: { id: "timeline_corner" },
          },
          [
            _c("div", { attrs: { id: "timeline_timestamp" } }, [
              _vm._v(_vm._s(_vm.timestamp)),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v("/")]),
            _vm._v(" "),
            _c("div", { attrs: { id: "timeline_framenumber" } }, [
              _vm._v(_vm._s(_vm.framenumber)),
            ]),
            _vm._v(" "),
            _vm.graph_editor_open
              ? _c("div", { staticClass: "channel_axis_selector" }, [
                  _c(
                    "div",
                    {
                      class: { selected: _vm.graph_editor_axis == "x" },
                      staticStyle: { color: "var(--color-axis-x)" },
                      on: {
                        click: function ($event) {
                          return _vm.setGraphEditorAxis("x")
                        },
                      },
                    },
                    [_vm._v("X")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: { selected: _vm.graph_editor_axis == "y" },
                      staticStyle: { color: "var(--color-axis-y)" },
                      on: {
                        click: function ($event) {
                          return _vm.setGraphEditorAxis("y")
                        },
                      },
                    },
                    [_vm._v("Y")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: { selected: _vm.graph_editor_axis == "z" },
                      staticStyle: { color: "var(--color-axis-z)" },
                      on: {
                        click: function ($event) {
                          return _vm.setGraphEditorAxis("z")
                        },
                      },
                    },
                    [_vm._v("Z")]
                  ),
                ])
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c("div", { attrs: { id: "timeline_time_wrapper" } }, [
          _c(
            "div",
            {
              style: {
                width: _vm.size * _vm.length + "px",
                left: -_vm.scroll_left + "px",
              },
              attrs: { id: "timeline_time" },
            },
            [
              _vm.custom_range[1]
                ? _c("div", {
                    style: {
                      left: _vm.custom_range[0] * _vm.size + "px",
                      width:
                        (_vm.custom_range[1] - _vm.custom_range[0]) * _vm.size +
                        "px",
                    },
                    attrs: { id: "timeline_custom_range_indicator" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.timecodes, function (timecode) {
                return _c(
                  "div",
                  {
                    key: timecode.text,
                    staticClass: "timeline_timecode",
                    style: {
                      left: timecode.time * _vm.size + "px",
                      width: timecode.width * _vm.size + "px",
                    },
                  },
                  [
                    _c("span", [_vm._v(_vm._s(timecode.text))]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "substeps" },
                      _vm._l(Math.ceil(timecode.substeps), function (n) {
                        return _c("div", { key: timecode.text + "-" + n })
                      }),
                      0
                    ),
                  ]
                )
              }),
              _vm._v(" "),
              _c("div", {
                style: { left: _vm.playhead * _vm.size + "px" },
                attrs: { id: "timeline_playhead" },
              }),
              _vm._v(" "),
              _vm.onion_skin_selectable
                ? _c("div", {
                    style: { left: _vm.onion_skin_time * _vm.size + "px" },
                    attrs: { id: "timeline_onion_skin_point" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                style: { left: _vm.animation_length * _vm.size + "px" },
                attrs: { id: "timeline_endbracket" },
              }),
              _vm._v(" "),
              _vm._l(_vm.markers, function (marker) {
                return _c(
                  "div",
                  {
                    staticClass: "timeline_marker tool",
                    style: {
                      left: marker.time * _vm.size + "px",
                      "--color": _vm.getColor(marker.color),
                    },
                    attrs: { uuid: marker.uuid },
                    on: {
                      contextmenu: function ($event) {
                        $event.preventDefault()
                        return marker.showContextMenu($event)
                      },
                      dblclick: function ($event) {
                        $event.preventDefault()
                        return marker.propertiesDialog()
                      },
                      click: function ($event) {
                        return marker.callPlayhead()
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "material-icons icon" }, [
                      _vm._v("beenhere"),
                    ]),
                    _vm._v(" "),
                    marker.name
                      ? _c("div", { staticClass: "tooltip" }, [
                          _vm._v(_vm._s(marker.name)),
                        ])
                      : _vm._e(),
                  ]
                )
              }),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.graph_editor_open && _vm.getSelectedGraphRange()
        ? _c(
            "div",
            {
              style: {
                top:
                  _vm.graph_offset -
                  _vm.getSelectedGraphRange()[1] * _vm.graph_size -
                  8 +
                  "px",
                height:
                  (_vm.getSelectedGraphRange()[1] -
                    _vm.getSelectedGraphRange()[0]) *
                    _vm.graph_size +
                  15 +
                  "px",
              },
              attrs: {
                id: "timeline_graph_editor_amplifier",
                title: "${tl('timeline.amplify')}",
              },
            },
            [
              _c("div", {
                on: {
                  mousedown: function ($event) {
                    return _vm.slideGraphAmplify($event, 0)
                  },
                  touchstart: function ($event) {
                    return _vm.slideGraphAmplify($event, 0)
                  },
                },
              }),
              _vm._v(" "),
              _c("div", {
                on: {
                  mousedown: function ($event) {
                    return _vm.slideGraphAmplify($event, 1)
                  },
                  touchstart: function ($event) {
                    return _vm.slideGraphAmplify($event, 1)
                  },
                },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "timeline_body",
          attrs: { id: "timeline_body" },
          on: {
            scroll: function ($event) {
              return _vm.updateScroll($event)
            },
          },
        },
        [
          _c(
            "div",
            {
              style: { width: _vm.size * _vm.length + _vm.head_width + "px" },
              attrs: { id: "timeline_body_inner" },
            },
            [
              _c(
                "aside",
                { attrs: { id: "timeline_body_channel_headers" } },
                [
                  _vm._l(_vm.animators, function (animator) {
                    return _c(
                      "li",
                      {
                        staticClass: "animator",
                        class: {
                          selected: animator.selected,
                          boneless: animator.displayPosition && !animator.node,
                        },
                        attrs: { uuid: animator.uuid },
                      },
                      [
                        _c("div", { staticClass: "animator_head_bar" }, [
                          _c(
                            "div",
                            {
                              staticClass: "channel_head",
                              style: {
                                left: "0px",
                                width: _vm.head_width + "px",
                              },
                              on: {
                                dblclick: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.toggleAnimator(animator)
                                },
                                contextmenu: function ($event) {
                                  $event.stopPropagation()
                                  return animator.showContextMenu($event)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "text_button",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.toggleAnimator(animator)
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "icon-open-state fa",
                                    class: {
                                      "fa-angle-right": !animator.expanded,
                                      "fa-angle-down": animator.expanded,
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(" "),
                              animator.node
                                ? _c("dynamic-icon", {
                                    attrs: {
                                      icon: animator.node.icon
                                        .replace("fa ", "")
                                        .replace(/ /g, "."),
                                      color: _vm.getNodeColor(animator.node),
                                    },
                                  })
                                : animator.particle
                                ? _c("dynamic-icon", {
                                    attrs: { icon: "wand_shine" },
                                  })
                                : _c("dynamic-icon", {
                                    staticStyle: {
                                      color: "var(--color-error)",
                                    },
                                    attrs: { icon: "help" },
                                  }),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "timeline_animator_name",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return animator.clickSelect()
                                    },
                                    mousedown: function ($event) {
                                      return _vm.dragAnimator(animator, $event)
                                    },
                                    touchstart: function ($event) {
                                      return _vm.dragAnimator(animator, $event)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t" +
                                      _vm._s(animator.name) +
                                      "\n\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "text_button",
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.removeAnimator(animator)
                                    },
                                  },
                                },
                                [
                                  _c("i", { staticClass: "material-icons" }, [
                                    _vm._v("remove"),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._l(
                          animator.channels,
                          function (channel_options, channel) {
                            return animator.expanded &&
                              _vm.channels[channel] != false &&
                              _vm.Condition(
                                channel_options.condition,
                                animator
                              ) &&
                              (!_vm.channels.hide_empty ||
                                animator[channel].length)
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "animator_channel_bar",
                                    style: _vm.graph_editor_open
                                      ? {}
                                      : { width: _vm.head_width + "px" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "channel_head",
                                        class: {
                                          selected:
                                            _vm.graph_editor_open &&
                                            animator.selected &&
                                            _vm.graph_editor_channel == channel,
                                        },
                                        style: {
                                          left: "0px",
                                          width: _vm.head_width + "px",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.selectChannel(
                                              animator,
                                              channel
                                            )
                                          },
                                          contextmenu: function ($event) {
                                            $event.stopPropagation()
                                            return animator.showContextMenu(
                                              $event
                                            )
                                          },
                                        },
                                      },
                                      [
                                        channel_options.mutable
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "text_button",
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return animator.toggleMuted(
                                                      channel
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "icon material-icons channel_mute",
                                                    class: {
                                                      disabled:
                                                        animator.muted[channel],
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          channel === "sound"
                                                            ? animator.muted[
                                                                channel
                                                              ]
                                                              ? "volume_off"
                                                              : "volume_up"
                                                            : animator.muted[
                                                                channel
                                                              ]
                                                            ? "visibility_off"
                                                            : "visibility"
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _c("div", {
                                              staticClass: "text_button",
                                            }),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(_vm._s(channel_options.name)),
                                        ]),
                                        _vm._v(" "),
                                        channel == "rotation" &&
                                        animator.type == "bone"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text_button rotation_global",
                                                class: {
                                                  off: !animator.rotation_global,
                                                },
                                                attrs: {
                                                  title:
                                                    "${tl('menu.animator.rotation_global')}",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    return _vm.toggleGlobalSpace(
                                                      animator
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "i",
                                                  {
                                                    staticClass:
                                                      "material-icons",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        animator.rotation_global
                                                          ? "public"
                                                          : "public_off"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "text_button",
                                            on: {
                                              click: function ($event) {
                                                $event.stopPropagation()
                                                return animator.createKeyframe(
                                                  null,
                                                  null,
                                                  channel,
                                                  true
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "i",
                                              { staticClass: "material-icons" },
                                              [_vm._v("add")]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e()
                          }
                        ),
                      ],
                      2
                    )
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "channel_head",
                    style: { width: _vm.head_width + "px" },
                    attrs: { id: "timeline_empty_head" },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c("canvas", {
                ref: "keyframe_canvas",
                style: { left: _vm.head_width + "px" },
                attrs: { id: "timeline_body_keyframe_canvas" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.clickKeyframeOnCanvas($event)
                  },
                  dblclick: function ($event) {
                    return _vm.callPlayHeadToKeyframeOnCanvas($event)
                  },
                  mousedown: function ($event) {
                    return _vm.dragOnCanvas($event)
                  },
                  touchstart: function ($event) {
                    return _vm.dragOnCanvas($event)
                  },
                  contextmenu: function ($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.openKeyframeContextMenuOnCanvas($event)
                  },
                  mousemove: function ($event) {
                    return _vm.hoverOnCanvas($event)
                  },
                  mouseleave: function ($event) {
                    return _vm.clearHoveredKeyframe()
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "section",
                { attrs: { id: "timeline_body_keyframe_backdrop" } },
                _vm._l(_vm.animators, function (animator) {
                  return !_vm.graph_editor_open
                    ? _c(
                        "li",
                        {
                          staticClass: "animator",
                          class: {
                            selected: animator.selected,
                            boneless:
                              animator.displayPosition && !animator.node,
                          },
                          attrs: { uuid: animator.uuid },
                        },
                        [
                          _c("div", { staticClass: "animator_head_bar" }),
                          _vm._v(" "),
                          _vm._l(
                            animator.channels,
                            function (channel_options, channel) {
                              return animator.expanded &&
                                _vm.channels[channel] != false &&
                                _vm.Condition(
                                  channel_options.condition,
                                  animator
                                ) &&
                                (!_vm.channels.hide_empty ||
                                  animator[channel].length)
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "animator_channel_bar",
                                      style: _vm.graph_editor_open
                                        ? {}
                                        : {
                                            width:
                                              _vm.size * _vm.length +
                                              _vm.head_width +
                                              "px",
                                          },
                                    },
                                    [
                                      !_vm.graph_editor_open
                                        ? _c(
                                            "div",
                                            { staticClass: "keyframe_section" },
                                            _vm._l(
                                              animator[channel],
                                              function (keyframe) {
                                                var _obj
                                                return _c(
                                                  "div",
                                                  {
                                                    staticClass: "keyframe",
                                                    class:
                                                      ((_obj = {}),
                                                      (_obj[
                                                        keyframe.channel
                                                      ] = true),
                                                      (_obj.selected =
                                                        keyframe.selected),
                                                      (_obj.has_expressions =
                                                        keyframe.has_expressions),
                                                      _obj),
                                                    style: {
                                                      left:
                                                        8 +
                                                        keyframe.time *
                                                          _vm.size +
                                                        "px",
                                                    },
                                                    attrs: {
                                                      id: keyframe.uuid,
                                                    },
                                                  },
                                                  [
                                                    keyframe.channel ==
                                                      "sound" &&
                                                    keyframe.data_points[0]
                                                      .file &&
                                                    _vm.waveforms[
                                                      keyframe.data_points[0]
                                                        .file
                                                    ]
                                                      ? _c(
                                                          "svg",
                                                          {
                                                            staticClass:
                                                              "keyframe_waveform",
                                                            style: {
                                                              width:
                                                                _vm.waveforms[
                                                                  keyframe
                                                                    .data_points[0]
                                                                    .file
                                                                ].duration *
                                                                _vm.size,
                                                            },
                                                          },
                                                          [
                                                            _c("polygon", {
                                                              attrs: {
                                                                points:
                                                                  _vm.getWaveformPoints(
                                                                    _vm
                                                                      .waveforms[
                                                                      keyframe
                                                                        .data_points[0]
                                                                        .file
                                                                    ].samples,
                                                                    _vm.size
                                                                  ),
                                                              },
                                                            }),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                : _vm._e()
                            }
                          ),
                        ],
                        2
                      )
                    : _vm._e()
                }),
                0
              ),
              _vm._v(" "),
              _vm.graph_editor_open
                ? _c(
                    "section",
                    {
                      ref: "graph_editor",
                      style: {
                        translate: "0 0",
                        left: _vm.head_width + "px",
                        top: _vm.scroll_top + "px",
                      },
                      attrs: { id: "timeline_graph_editor" },
                    },
                    [
                      _c(
                        "svg",
                        {
                          style: {
                            "margin-left":
                              _vm.clamp(_vm.scroll_left, 9, Infinity) + "px",
                          },
                        },
                        [
                          _c("path", {
                            staticStyle: { stroke: "var(--color-grid)" },
                            attrs: { d: _vm.zero_line },
                          }),
                          _vm._v(" "),
                          _vm.graph_editor_channel == "scale"
                            ? _c("path", {
                                staticStyle: {
                                  stroke: "var(--color-grid)",
                                  "stroke-dasharray": "6",
                                },
                                attrs: { d: _vm.one_line },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.rulers, function (ruler) {
                            return [
                              _c("path", {
                                staticStyle: {
                                  stroke: "var(--color-grid)",
                                  "stroke-width": "0.5px",
                                },
                                attrs: { d: ruler.path },
                              }),
                              _vm._v(" "),
                              _c("text", { attrs: { y: ruler.position - 4 } }, [
                                _vm._v(_vm._s(ruler.label)),
                              ]),
                            ]
                          }),
                          _vm._v(" "),
                          _vm._l(_vm.loop_graphs, function (loop_graph, i) {
                            return _c("path", {
                              staticClass: "loop_graph",
                              class: {
                                selected:
                                  _vm.loop_graphs.length == 0 ||
                                  i == _vm.graph_editor_axis_number,
                              },
                              staticStyle: {
                                stroke: "var(--color-loop_graph)",
                              },
                              attrs: { d: loop_graph },
                            })
                          }),
                          _vm._v(" "),
                          _vm.graphs.length == 3
                            ? _c("path", {
                                staticClass: "main_graph",
                                style: {
                                  stroke:
                                    "var(--color-axis-" +
                                    _vm.getAxisLetter(
                                      (_vm.graph_editor_axis_number + 1) % 3
                                    ) +
                                    ")",
                                },
                                attrs: {
                                  d: _vm.graphs[
                                    (_vm.graph_editor_axis_number + 1) % 3
                                  ],
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.graphs.length == 3
                            ? _c("path", {
                                staticClass: "main_graph",
                                style: {
                                  stroke:
                                    "var(--color-axis-" +
                                    _vm.getAxisLetter(
                                      (_vm.graph_editor_axis_number + 2) % 3
                                    ) +
                                    ")",
                                },
                                attrs: {
                                  d: _vm.graphs[
                                    (_vm.graph_editor_axis_number + 2) % 3
                                  ],
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("path", {
                            staticClass: "main_graph selected",
                            style: {
                              stroke:
                                "var(--color-axis-" +
                                _vm.graph_editor_axis +
                                ")",
                            },
                            attrs: {
                              d: _vm.graphs[
                                _vm.graphs.length == 3
                                  ? _vm.graph_editor_axis_number
                                  : 0
                              ],
                            },
                          }),
                        ],
                        2
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                staticClass: "selection_rectangle",
                attrs: { id: "timeline_selector" },
              }),
            ]
          ),
        ]
      ),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-a4666dc8_0", { source: "\n#timeline_body_inner {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n    align-items: flex-start;\n}\n#timeline_body_channel_headers {\n\tdisplay: flex;\n\tflex-direction: column;\n    position: sticky;\n    left: 0px;\n    z-index: 4;\n    min-height: stretch;\n}\n#timeline_body_keyframe_canvas {\n    position: sticky;\n\ttop: 0;\n    z-index: 2;\n}\n#timeline_body_keyframe_backdrop {\n    position: sticky;\n\ttop: 0;\n    z-index: 0;\n\twidth: stretch;\n\theight: stretch;\n}\n.keyframe.graph_keyframe > svg {\n\tmargin: none;\n\tpointer-events: inherit;\n}\n.animator_channel_bar {\n\toverflow: clip;\n}\n", map: {"version":3,"sources":["js/animations/Timeline.vue"],"names":[],"mappings":";AAopDA;IACA,aAAA;IACA,mBAAA;IACA,iBAAA;IACA,2BAAA;IACA,uBAAA;AACA;AAEA;CACA,aAAA;CACA,sBAAA;IACA,gBAAA;IACA,SAAA;IACA,UAAA;IACA,mBAAA;AACA;AAEA;IACA,gBAAA;CACA,MAAA;IACA,UAAA;AACA;AAEA;IACA,gBAAA;CACA,MAAA;IACA,UAAA;CACA,cAAA;CACA,eAAA;AACA;AAEA;CACA,YAAA;CACA,uBAAA;AACA;AAEA;CACA,cAAA;AACA","file":"Timeline.vue","sourcesContent":["<template>\n\t<div id=\"timeline_vue\" :class=\"{graph_editor: graph_editor_open}\" :style=\"{'--timeline-height': timeline_height + 'px'}\">\n\t\t<div id=\"timeline_header\">\n\t\t\t<div id=\"timeline_corner\" :style=\"{width: head_width+'px'}\">\n\t\t\t\t<div id=\"timeline_timestamp\">{{ timestamp }}</div>\n\t\t\t\t<span>/</span>\n\t\t\t\t<div id=\"timeline_framenumber\">{{ framenumber }}</div>\n\t\t\t\t<div class=\"channel_axis_selector\" v-if=\"graph_editor_open\">\n\t\t\t\t\t<div @click=\"setGraphEditorAxis('x');\" :class=\"{selected: graph_editor_axis == 'x'}\" style=\"color: var(--color-axis-x);\">X</div>\n\t\t\t\t\t<div @click=\"setGraphEditorAxis('y');\" :class=\"{selected: graph_editor_axis == 'y'}\" style=\"color: var(--color-axis-y);\">Y</div>\n\t\t\t\t\t<div @click=\"setGraphEditorAxis('z');\" :class=\"{selected: graph_editor_axis == 'z'}\" style=\"color: var(--color-axis-z);\">Z</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div id=\"timeline_time_wrapper\">\n\t\t\t<div id=\"timeline_time\" :style=\"{width: (size*length)+'px', left: -scroll_left+'px'}\">\n\t\t\t\t\t<div id=\"timeline_custom_range_indicator\" v-if=\"custom_range[1]\"\n\t\t\t\t\t\t:style=\"{left: (custom_range[0] * size) + 'px', width: ((custom_range[1] - custom_range[0]) * size) + 'px'}\"\n\t\t\t\t\t/>\n\t\t\t\t\t<div v-for=\"timecode in timecodes\" class=\"timeline_timecode\" :key=\"timecode.text\" :style=\"{left: (timecode.time * size) + 'px', width: (timecode.width * size) + 'px'}\">\n\t\t\t\t\t\t<span>{{ timecode.text }}</span>\n\t\t\t\t\t\t<div class=\"substeps\">\n\t\t\t\t\t\t\t<div v-for=\"n in Math.ceil(timecode.substeps)\" :key=\"timecode.text + '-' + n\"></div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div id=\"timeline_playhead\"\n\t\t\t\t\t\t:style=\"{left: (playhead * size) + 'px'}\"\n\t\t\t\t\t/>\n\t\t\t\t\t<div id=\"timeline_onion_skin_point\"\n\t\t\t\t\t\tv-if=\"onion_skin_selectable\"\n\t\t\t\t\t\t:style=\"{left: (onion_skin_time * size) + 'px'}\"\n\t\t\t\t\t/>\n\t\t\t\t\t<div id=\"timeline_endbracket\"\n\t\t\t\t\t\t:style=\"{left: (animation_length * size) + 'px'}\"\n\t\t\t\t\t/>\n\t\t\t\t\t<div\n\t\t\t\t\t\tv-for=\"marker in markers\"\n\t\t\t\t\t\tclass=\"timeline_marker tool\"\n\t\t\t\t\t\t:style=\"{left: (marker.time * size) + 'px', '--color': getColor(marker.color)}\"\n\t\t\t\t\t\t:uuid=\"marker.uuid\"\n\t\t\t\t\t\t@contextmenu.prevent=\"marker.showContextMenu($event)\"\n\t\t\t\t\t\t@dblclick.prevent=\"marker.propertiesDialog()\"\n\t\t\t\t\t\t@click=\"marker.callPlayhead()\"\n\t\t\t\t\t>\n\t\t\t\t\t\t<i class=\"material-icons icon\">beenhere</i>\n\t\t\t\t\t\t<div class=\"tooltip\" v-if=\"marker.name\">{{ marker.name }}</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div id=\"timeline_graph_editor_amplifier\"\n\t\t\tv-if=\"graph_editor_open && getSelectedGraphRange()\"\n\t\t\t:style=\"{top: (graph_offset - getSelectedGraphRange()[1] * graph_size - 8) + 'px', height: ((getSelectedGraphRange()[1] - getSelectedGraphRange()[0]) * graph_size + 15) + 'px'}\"\n\t\t\ttitle=\"${tl('timeline.amplify')}\"\n\t\t>\n\t\t\t<div @mousedown=\"slideGraphAmplify($event, 0)\" @touchstart=\"slideGraphAmplify($event, 0)\"></div>\n\t\t\t<div @mousedown=\"slideGraphAmplify($event, 1)\" @touchstart=\"slideGraphAmplify($event, 1)\"></div>\n\t\t</div>\n\t\t<div id=\"timeline_body\" ref=\"timeline_body\" @scroll=\"updateScroll($event)\">\n\t\t\t<div id=\"timeline_body_inner\" :style=\"{width: (size*length + head_width)+'px'}\">\n\t\t\t\t<aside id=\"timeline_body_channel_headers\">\n\t\t\t\t\t<li \n\t\t\t\t\t\tv-for=\"animator in animators\" \n\t\t\t\t\t\tclass=\"animator\" \n\t\t\t\t\t\t:class=\"{selected: animator.selected, boneless: animator.displayPosition && !animator.node}\" \n\t\t\t\t\t\t:uuid=\"animator.uuid\" \n\t\t\t\t\t>\n\t\t\t\t\t\t<div class=\"animator_head_bar\">\n\t\t\t\t\t\t\t<div class=\"channel_head\" :style=\"{left: '0px', width: head_width+'px'}\" @dblclick.stop=\"toggleAnimator(animator)\" @contextmenu.stop=\"animator.showContextMenu($event)\">\n\t\t\t\t\t\t\t\t<div class=\"text_button\" @click.stop=\"toggleAnimator(animator)\">\n\t\t\t\t\t\t\t\t\t<i class=\"icon-open-state fa\" :class=\"{'fa-angle-right': !animator.expanded, 'fa-angle-down': animator.expanded}\"></i>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<dynamic-icon v-if=\"animator.node\" :icon=\"animator.node.icon.replace('fa ', '').replace(/ /g, '.')\" :color=\"getNodeColor(animator.node)\" />\n\t\t\t\t\t\t\t\t<dynamic-icon v-else-if=\"animator.particle\" :icon=\"'wand_shine'\" />\n\t\t\t\t\t\t\t\t<dynamic-icon v-else :icon=\"'help'\" style=\"color: var(--color-error)\" />\n\t\t\t\t\t\t\t\t<span class=\"timeline_animator_name\" @click.stop=\"animator.clickSelect();\" @mousedown=\"dragAnimator(animator, $event)\" @touchstart=\"dragAnimator(animator, $event)\">\n\t\t\t\t\t\t\t\t\t{{animator.name}}\n\t\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t\t\t<div class=\"text_button\" @click.stop=\"removeAnimator(animator)\">\n\t\t\t\t\t\t\t\t\t<i class=\"material-icons\">remove</i>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"animator_channel_bar\"\n\t\t\t\t\t\t\tv-for=\"(channel_options, channel) in animator.channels\"\n\t\t\t\t\t\t\tv-if=\"animator.expanded && channels[channel] != false && Condition(channel_options.condition, animator) && (!channels.hide_empty || animator[channel].length)\"\n\t\t\t\t\t\t\t:style=\"graph_editor_open ? {} : {width: head_width+'px'}\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<div class=\"channel_head\"\n\t\t\t\t\t\t\t\t:class=\"{selected: graph_editor_open && animator.selected && graph_editor_channel == channel}\"\n\t\t\t\t\t\t\t\t:style=\"{left: '0px', width: head_width+'px'}\"\n\t\t\t\t\t\t\t\t@click.stop=\"selectChannel(animator, channel);\"\n\t\t\t\t\t\t\t\t@contextmenu.stop=\"animator.showContextMenu($event)\"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t<div class=\"text_button\" v-if=\"channel_options.mutable\" @click.stop=\"animator.toggleMuted(channel)\">\n\t\t\t\t\t\t\t\t\t<i class=\"icon material-icons channel_mute\" :class=\"{disabled: animator.muted[channel]}\">\n\t\t\t\t\t\t\t\t\t\t{{ channel === 'sound' ? (animator.muted[channel] ? 'volume_off' : 'volume_up') : (animator.muted[channel] ? 'visibility_off' : 'visibility') }}\n\t\t\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"text_button\" v-else></div>\n\t\t\t\t\t\t\t\t<span>{{ channel_options.name }}</span>\n\t\t\t\t\t\t\t\t<div class=\"text_button rotation_global\" :class=\"{off: !animator.rotation_global}\"\n\t\t\t\t\t\t\t\t\tv-if=\"channel == 'rotation' && animator.type == 'bone'\"\n\t\t\t\t\t\t\t\t\ttitle=\"${tl('menu.animator.rotation_global')}\"\n\t\t\t\t\t\t\t\t\t@click.stop=\"toggleGlobalSpace(animator)\"\n\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t<i class=\"material-icons\">{{ animator.rotation_global ? 'public' : 'public_off' }}</i>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<div class=\"text_button\" @click.stop=\"animator.createKeyframe(null, null, channel, true)\">\n\t\t\t\t\t\t\t\t\t<i class=\"material-icons\">add</i>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</li>\n\t\t\t\t\t<div id=\"timeline_empty_head\" class=\"channel_head\" :style=\"{width: head_width+'px'}\" />\n\t\t\t\t</aside>\n\t\t\t\t<!-- --------------------------------------------------------------------- -->\n\t\t\t\t<!-- Timeline keyframe canvas overlay (for all keyframes, graph & channel) -->\n\t\t\t\t<!-- --------------------------------------------------------------------- -->\n\t\t\t\t<canvas \n\t\t\t\t\tid=\"timeline_body_keyframe_canvas\" \n\t\t\t\t\tref=\"keyframe_canvas\"\n\t\t\t\t\t:style=\"{left: `${head_width}px`}\"\n\t\t\t\t\t@click.stop=\"clickKeyframeOnCanvas($event)\" \n\t\t\t\t\t@dblclick=\"callPlayHeadToKeyframeOnCanvas($event)\" \n\t\t\t\t\t@mousedown=\"dragOnCanvas($event)\" \n\t\t\t\t\t@touchstart=\"dragOnCanvas($event)\"\n\t\t\t\t\t@contextmenu.prevent.stop=\"openKeyframeContextMenuOnCanvas($event)\"\n\t\t\t\t\t@mousemove=\"hoverOnCanvas($event)\"\n\t\t\t\t\t@mouseleave=\"clearHoveredKeyframe()\"\n\t\t\t\t/>\n\t\t\t\t<!-- ----------------------------- -->\n\t\t\t\t<!-- Timeline regular channels DOM -->\n\t\t\t\t<!-- ----------------------------- -->\n\t\t\t\t<section id=\"timeline_body_keyframe_backdrop\">\n\t\t\t\t\t<li \n\t\t\t\t\t\tv-for=\"animator in animators\" \n\t\t\t\t\t\tv-if=\"!graph_editor_open\" \n\t\t\t\t\t\tclass=\"animator\" \n\t\t\t\t\t\t:class=\"{selected: animator.selected, boneless: animator.displayPosition && !animator.node}\" \n\t\t\t\t\t\t:uuid=\"animator.uuid\"\n\t\t\t\t\t>\n\t\t\t\t\t\t<div class=\"animator_head_bar\" />\n\t\t\t\t\t\t<div class=\"animator_channel_bar\"\n\t\t\t\t\t\t\tv-for=\"(channel_options, channel) in animator.channels\"\n\t\t\t\t\t\t\tv-if=\"animator.expanded && channels[channel] != false && Condition(channel_options.condition, animator) && (!channels.hide_empty || animator[channel].length)\"\n\t\t\t\t\t\t\t:style=\"graph_editor_open ? {} : {width: (size*length + head_width)+'px'}\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<div class=\"keyframe_section\" v-if=\"!graph_editor_open\">\n\t\t\t\t\t\t\t\t<div\n\t\t\t\t\t\t\t\t\tv-for=\"keyframe in animator[channel]\"\n\t\t\t\t\t\t\t\t\tclass=\"keyframe\"\n\t\t\t\t\t\t\t\t\t:class=\"{[keyframe.channel]: true, selected: keyframe.selected, has_expressions: keyframe.has_expressions}\"\n\t\t\t\t\t\t\t\t\t:id=\"keyframe.uuid\"\n\t\t\t\t\t\t\t\t\t:style=\"{left: (8 + keyframe.time * size) + 'px'}\"\n\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t<svg class=\"keyframe_waveform\" v-if=\"keyframe.channel == 'sound' && keyframe.data_points[0].file && waveforms[keyframe.data_points[0].file]\" :style=\"{width: waveforms[keyframe.data_points[0].file].duration * size}\">\n\t\t\t\t\t\t\t\t\t\t<polygon :points=\"getWaveformPoints(waveforms[keyframe.data_points[0].file].samples, size)\"></polygon>\n\t\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</li>\n\t\t\t\t</section>\n\t\t\t\t<!-- ------------------------- -->\n\t\t\t\t<!-- Timeline Graph editor DOM -->\n\t\t\t\t<!-- ------------------------- -->\n\t\t\t\t<section v-if=\"graph_editor_open\" id=\"timeline_graph_editor\" ref=\"graph_editor\" :style=\"{translate: '0 0', left: head_width + 'px', top: scroll_top + 'px'}\">\n\t\t\t\t\t<svg :style=\"{'margin-left': clamp(scroll_left, 9, Infinity) + 'px'}\">\n\t\t\t\t\t\t<path :d=\"zero_line\" style=\"stroke: var(--color-grid);\"></path>\n\t\t\t\t\t\t<path :d=\"one_line\" style=\"stroke: var(--color-grid); stroke-dasharray: 6;\" v-if=\"graph_editor_channel == 'scale'\"></path>\n\t\t\t\t\t\t<template v-for=\"ruler in rulers\">\n\t\t\t\t\t\t\t<path :d=\"ruler.path\" style=\"stroke: var(--color-grid); stroke-width: 0.5px;\"></path>\n\t\t\t\t\t\t\t<text :y=\"ruler.position - 4\">{{ ruler.label }}</text>\n\t\t\t\t\t\t</template>\n\n\t\t\t\t\t\t<path v-for=\"(loop_graph, i) in loop_graphs\"\n\t\t\t\t\t\t\t:d=\"loop_graph\"\n\t\t\t\t\t\t\tclass=\"loop_graph\"\n\t\t\t\t\t\t\t:class=\"{selected: loop_graphs.length == 0 || i == graph_editor_axis_number}\"\n\t\t\t\t\t\t\tstyle=\"stroke: var(--color-loop_graph);\"\n\t\t\t\t\t\t></path>\n\t\t\t\t\t\t<path v-if=\"graphs.length == 3\"\n\t\t\t\t\t\t\t:d=\"graphs[(graph_editor_axis_number+1) % 3]\"\n\t\t\t\t\t\t\tclass=\"main_graph\"\n\t\t\t\t\t\t\t:style=\"{stroke: 'var(--color-axis-' + getAxisLetter((graph_editor_axis_number+1) % 3) + ')'}\"\n\t\t\t\t\t\t></path>\n\t\t\t\t\t\t<path v-if=\"graphs.length == 3\"\n\t\t\t\t\t\t\t:d=\"graphs[(graph_editor_axis_number+2) % 3]\"\n\t\t\t\t\t\t\tclass=\"main_graph\"\n\t\t\t\t\t\t\t:style=\"{stroke: 'var(--color-axis-' + getAxisLetter((graph_editor_axis_number+2) % 3) + ')'}\"\n\t\t\t\t\t\t></path>\n\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t:d=\"graphs[graphs.length == 3 ? graph_editor_axis_number : 0]\"\n\t\t\t\t\t\t\tclass=\"main_graph selected\"\n\t\t\t\t\t\t\t:style=\"{stroke: 'var(--color-axis-' + graph_editor_axis + ')'}\"\n\t\t\t\t\t\t></path>\n\t\t\t\t\t</svg>\n\t\t\t\t</section>\n\n\t\t\t\t<div id=\"timeline_selector\" class=\"selection_rectangle\"></div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</template>\n\n<script lang=\"js\">\nimport { tl } from '../languages';\n\nexport default {\n\tname: 'panel-timeline',\n\tdata() {return {\n\t\tsize: 300,\n\t\tlength: 10,\n\t\ttimeline_height: 100,\n\t\tanimation_length: 0,\n\t\tscroll_left: 0,\n\t\tscroll_top: 0,\n\t\thead_width: Blockbench.isMobile ? 108 : Interface.data.timeline_head,\n\t\ttimecodes: [],\n\t\tanimators: Timeline.animators,\n\t\tmarkers: [],\n\t\tcustom_range: Timeline.custom_range,\n\t\twaveforms: Timeline.waveforms,\n\t\tfocus_channel: null,\n\t\tplayhead: Timeline.time,\n\t\ttimestamp: '0',\n\t\tframenumber: '0',\n\n\t\tgraph_editor_open: false,\n\t\tgraph_editor_channel: 'rotation',\n\t\tgraph_editor_axis: 'x',\n\t\tgraph_offset: 200,\n\t\tgraph_size: 200,\n\t\tshow_other_graphs: true,\n\t\tinclude_other_graphs: true,\n\t\tshow_zero_line: true,\n\t\tshow_all_handles: !Settings.get('only_selected_bezier_handles'),\n\t\tloop_graphs: [''],\n\n\t\tonion_skin_selectable: BarItems.animation_onion_skin.value,\n\t\tonion_skin_time: 0,\n\n\t\tchannels: StateMemory.timeline_channels,\n\n\t\tsamplingScale: 4.0,\n\n\t\tkeyframeHoverUuid: \"\",\n\t\tbezierHandleHover: {\n\t\t\tkeyUuid: \"\",\n\t\t\tside: \"\"\n\t\t},\n\t\tkeyframeIcons: { // There has to be a better way to type these characters, but this is the best I found for now - Aza\n\t\t\tlinear: {\n\t\t\t  \tdefault: \"\",\n\t\t\t  \tdiscontinuous:  \"\",\n\t\t\t\tmolang: \"\",\n\t\t\t\tdiscontinuous_molang: \"\"\n\t\t\t},\n\t\t\tbezier: {\n\t\t\t \tdefault: \"\",\n\t\t\t\tdiscontinuous: \"\",\n\t\t\t \tmolang: \"\",\n\t\t\t\tdiscontinuous_molang: \"\"\n\t\t\t},\n\t\t\tsmooth: {\n\t\t\t  \tdefault: \"\",\n\t\t\t  \tmolang: \"\"\n\t\t\t},\n\t\t\tstep: {\n\t\t\t  \tdefault: \"\",\n\t\t\t  \tdiscontinuous: \"\",\n\t\t\t\tmolang: \"\",\n\t\t\t\tdiscontinuous_molang: \"\"\n\t\t\t},\n\t\t\thidden: {\n\t\t\t  \tdefault: \"\",\n\t\t\t\tdiscontinuous: \"\",\n\t\t\t\tmolang: \"\"\n\t\t\t}\n\t\t}\n\t}},\n\twatch: {\n\t\tsize() {this.updateTimecodes()},\n\t\tlength() {this.updateTimecodes()},\n\t\tscroll_left() {this.updateTimecodes()},\n\t},\n\tcomputed: {\n\t\tgraph_editor_animator() {\n\t\t\treturn this.animators.find(animator => animator.selected && animator instanceof BoneAnimator);\n\t\t},\n\t\tzero_line() {\n\t\t\tlet height = this.graph_offset;\n\t\t\treturn `M0 ${height} L10000 ${height}`\n\t\t},\n\t\tone_line() {\n\t\t\tlet height = this.graph_offset - this.graph_size;\n\t\t\treturn `M0 ${height} L10000 ${height}`\n\t\t},\n\t\trulers() {\n\t\t\tlet lines = [];\n\t\t\tlet values = [0];\n\n\t\t\tlet interval_options = [1, 2, 4, 8, 10, 20, 25, 50, 100, 200, 250, 400, 500];\n\t\t\tlet estimate = 100 / Timeline.vue.graph_size;\n\t\t\tif (estimate > 500) return values;\n\t\t\tlet interval = Math.snapToValues(estimate, interval_options);\n\t\t\tlet box_height = Timeline.vue.$refs.timeline_body.clientHeight;\n\n\t\t\tfor (let i = 1; i < 20; i += 1) {\n\t\t\t\tlet value = i * interval;\n\t\t\t\tlet keep_going = false;\n\t\t\t\tif (this.graph_offset - value * this.graph_size > 0) {\n\t\t\t\t\tvalues.push(value);\n\t\t\t\t\tkeep_going = true;\n\t\t\t\t}\n\t\t\t\tif (this.graph_offset + value * this.graph_size < box_height) {\n\t\t\t\t\tvalues.push(i * -interval);\n\t\t\t\t\tkeep_going = true;\n\t\t\t\t}\n\t\t\t\tif (!keep_going) break;\n\t\t\t}\n\n\t\t\tvalues.forEach(value => {\n\t\t\t\tlet height = this.graph_offset - this.graph_size * value;\n\t\t\t\tlines.push({\n\t\t\t\t\tposition: height,\n\t\t\t\t\tlabel: Math.round(value),\n\t\t\t\t\tpath: `M0 ${height} L10000 ${height}`\n\t\t\t\t});\n\t\t\t})\n\t\t\treturn lines;\n\t\t},\n\t\tgraphs() {\n\t\t\tlet ba = this.graph_editor_animator;\n\t\t\tif (!ba || !ba[this.graph_editor_channel] || !ba[this.graph_editor_channel].length) {\n\t\t\t\tthis.loop_graphs.empty();\n\t\t\t\treturn [];\n\t\t\t}\n\t\t\tlet original_time = Timeline.time;\n\t\t\tlet step = 2;\n\t\t\tlet clientWidth = this.$refs.timeline_body ? this.$refs.timeline_body.clientWidth : 400;\n\t\t\tlet clientHeight = this.$refs.timeline_body ? this.$refs.timeline_body.clientHeight : 400;\n\t\t\tlet keyframes = ba[this.graph_editor_channel];\n\t\t\tlet points = [];\n\t\t\tlet loop_points = [];\n\n\t\t\tlet min = this.show_zero_line ? -1 : Timeline.graph_editor_limit,\n\t\t\t\tmax = this.show_zero_line ? 1 : -Timeline.graph_editor_limit;\n\n\t\t\tfor (let time = Math.clamp(this.scroll_left - 9, 0, Infinity); time < (clientWidth + this.scroll_left - this.head_width); time += step) {\n\t\t\t\tTimeline.time = time / this.size;\n\n\t\t\t\tlet snap_kf = keyframes.find(kf => Timeline.time <= kf.time && Timeline.time > kf.time - step / this.size );\n\t\t\t\tif (snap_kf) {\n\t\t\t\t\tTimeline.time = snap_kf.time;\n\t\t\t\t}\n\t\t\t\tAnimator.resetLastValues();\n\t\t\t\tlet values = [\n\t\t\t\t\t(this.show_other_graphs || this.graph_editor_axis === 'x') ? ba.interpolate(this.graph_editor_channel, false, 'x') : 0,\n\t\t\t\t\t(this.show_other_graphs || this.graph_editor_axis === 'y') ? ba.interpolate(this.graph_editor_channel, false, 'y') : 0,\n\t\t\t\t\t(this.show_other_graphs || this.graph_editor_axis === 'z') ? ba.interpolate(this.graph_editor_channel, false, 'z') : 0\n\t\t\t\t];\n\t\t\t\tlet value = values[this.graph_editor_axis_number];\n\t\t\t\tif (snap_kf) snap_kf.display_value = value;\n\t\t\t\t\n\t\t\t\tif (Timeline.time > Animation.selected.length && Animation.selected.length && Animation.selected.loop === 'loop') {\n\t\t\t\t\tif (points.length && !loop_points.length) loop_points.push(points.last())\n\t\t\t\t\tloop_points.push(values);\n\t\t\t\t} else {\n\t\t\t\t\tpoints.push(values);\n\t\t\t\t\tif (this.show_other_graphs && this.include_other_graphs) {\n\t\t\t\t\t\tmin = Math.min(min, ...values);\n\t\t\t\t\t\tmax = Math.max(max, ...values);\n\t\t\t\t\t} else {\n\t\t\t\t\t\tmin = Math.min(min, value);\n\t\t\t\t\t\tmax = Math.max(max, value);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\tkeyframes.forEach(kf => {\n\t\t\t\tif (kf.interpolation === 'bezier') {\n\t\t\t\t\tmin = Math.min(min, kf.display_value + kf.bezier_left_value[this.graph_editor_axis_number]);\n\t\t\t\t\tmax = Math.max(max, kf.display_value + kf.bezier_left_value[this.graph_editor_axis_number]);\n\t\t\t\t\tmin = Math.min(min, kf.display_value + kf.bezier_right_value[this.graph_editor_axis_number]);\n\t\t\t\t\tmax = Math.max(max, kf.display_value + kf.bezier_right_value[this.graph_editor_axis_number]);\n\t\t\t\t}\n\t\t\t})\n\t\t\t\n\t\t\tTimeline.time = original_time;\n\n\t\t\tlet padding = 16;\n\t\t\tlet min_size = 2.4;\n\t\t\tlet unit_size = Math.clamp(max-min, min_size, Timeline.graph_editor_limit);\n\t\t\tthis.graph_size = (clientHeight - 2*padding) / unit_size;\n\t\t\tlet blend = Math.clamp(1 - (max-min) / min_size, 0, 1)\n\t\t\tthis.graph_offset = clientHeight - padding + (this.graph_size * (min - unit_size/2 * blend ) );\n\n\t\t\tlet graphs = this.show_other_graphs ? ['', '', ''] : [''];\n\t\t\tpoints.forEach((values, i) => {\n\t\t\t\tlet command = i == 0 ? 'M' : 'L';\n\t\t\t\tif (this.show_other_graphs) {\n\t\t\t\t\tvalues.forEach((value, axis) => {\n\t\t\t\t\t\tgraphs[axis] += `${command}${i*step} ${this.graph_offset - value * this.graph_size} `;\n\t\t\t\t\t})\n\t\t\t\t} else {\n\t\t\t\t\tgraphs[0] += `${command}${i*step} ${this.graph_offset - values[this.graph_editor_axis_number] * this.graph_size} `;\n\t\t\t\t}\n\t\t\t})\n\n\t\t\tthis.loop_graphs.empty();\n\t\t\tif (loop_points.length) {\n\t\t\t\tif (this.show_other_graphs) {\n\t\t\t\t\tthis.loop_graphs.push('', '', '');\n\t\t\t\t} else {\n\t\t\t\t\tthis.loop_graphs.push('');\n\t\t\t\t}\n\t\t\t\tloop_points.forEach((values, i) => {\n\t\t\t\t\tlet command = i == 0 ? 'M' : 'L';\n\t\t\t\t\ti = i + points.length - 1;\n\t\t\t\t\tif (this.show_other_graphs) {\n\t\t\t\t\t\tvalues.forEach((value, axis) => {\n\t\t\t\t\t\t\tthis.loop_graphs[axis] += `${command}${i*step} ${this.graph_offset - value * this.graph_size} `;\n\t\t\t\t\t\t})\n\t\t\t\t\t} else {\n\t\t\t\t\t\tthis.loop_graphs[0] += `${command}${i*step} ${this.graph_offset - values[this.graph_editor_axis_number] * this.graph_size} `;\n\t\t\t\t\t}\n\t\t\t\t})\n\t\t\t}\n\t\t\t\n\t\t\tthis.refreshTimelineCanvas();\n\t\t\treturn graphs;\n\t\t},\n\t\tgraph_editor_axis_number() {\n\t\t\treturn getAxisNumber(this.graph_editor_axis)\n\t\t}\n\t},\n\tmethods: {\n\t\ttl,\n\t\tsetGraphEditorAxis(axis) {\n\t\t\tthis.graph_editor_axis = axis; \n\t\t\tthis.refreshTimelineCanvas();\n\t\t},\n\t\tclearTimelineCanvas() {\n\t\t\tlet bodyCanvas = $('#timeline_body_keyframe_canvas').get(0);\n\t\t\tlet context = bodyCanvas.getContext(\"2d\");\n\t\t\tcontext.clearRect(0, 0, bodyCanvas.width, bodyCanvas.height);\n\t\t},\n\t\tshouldCullKeyframeOnGraph(keyframe) {\n\t\t\tif (!this.graph_editor_open) return false;\n\t\t\tlet body = $('#timeline_body').get(0);\n\t\t\tlet timelineStyle = window.getComputedStyle(body);\n\t\t\tlet rectHeight = body.clientHeight;\n\t\t\tlet rectWidth = body.clientWidth - this.head_width;\n\t\t\tlet scrollOffsetY = body.scrollTop;\n\t\t\tlet scrollOffsetX = body.scrollLeft;\n\n\t\t\tlet keyRadius = timelineStyle.getPropertyValue(\"--keyframe-radius\").trim();\n\t\t\tlet keyHoveredRadius = timelineStyle.getPropertyValue(\"--keyframe-radius-hover\").trim();\n\t\t\tlet handleDiameter = timelineStyle.getPropertyValue(\"--keyframe-bezier-handle-diameter\").trim();\n\t\t\tlet keyHoveredHalfradius = keyHoveredRadius / 2.0;\n\t\t\tlet keyHalfRadius = keyRadius / 2.0;\n\t\t\tlet handleRadius = handleDiameter / 2.0;\n\t\t\tlet size = this.size;\n\t\t\tlet graphSize = this.graph_size;\n\t\t\tlet graphOffset = this.graph_offset;\n\t\t\tlet graphAxis = this.graph_editor_axis;\n\t\t\tlet hoveredKeyframe = this.keyframeHoverUuid;\n\t\t\tlet hoveredBezierHandle = this.bezierHandleHover;\n\n\t\t\tlet timeStamp = keyframe.time;\n\t\t\tlet isHovered = (hoveredKeyframe === keyframe.uuid);\n\t\t\tlet anyHandleHovered = (hoveredBezierHandle.keyUuid === keyframe.uuid);\n\t\t\tlet keyHalfScale = (isHovered || anyHandleHovered) ? keyHoveredHalfradius : keyHalfRadius;\n\n\t\t\t// Get keyframe X and Y without the text box offset\n\t\t\tlet keyX = ((timeStamp * size) + keyHalfRadius - scrollOffsetX);\n\t\t\tlet keyY = (graphOffset - (keyframe.display_value * graphSize) - scrollOffsetY);\n\t\t\t\n\t\t\t// Get keyframe X and Y with the text box offset\n\t\t\tlet posX = (timeStamp * size) - (keyHalfScale - keyHoveredHalfradius) - scrollOffsetX;\n\t\t\tlet posY = graphOffset - (keyframe.display_value * graphSize) - keyHalfScale - scrollOffsetY;\n\t\t\t\n\t\t\t// Handle position info\n\t\t\tlet axis = getAxisNumber(graphAxis);\n\t\t\tlet leftOffsetX = (keyframe[`bezier_left_time`][axis] * size) + keyX;\n\t\t\tlet rightOffsetX = (keyframe[`bezier_right_time`][axis] * size) + keyX;\n\t\t\tlet leftOffsetY = (-keyframe[`bezier_left_value`][axis] * graphSize) + keyY;\n\t\t\tlet rightOffsetY = (-keyframe[`bezier_right_value`][axis] * graphSize) + keyY;\n\n\t\t\t// Checks\n\t\t\tlet leftHandleOutOnLeft = (leftOffsetX < (handleRadius / 2.0));\n\t\t\tlet leftHandleOutOnTop = (leftOffsetY < (handleRadius / 2.0));\n\t\t\tlet leftHandleOutOnRight = (leftOffsetX > rectWidth + (handleRadius / 2.0));\n\t\t\tlet leftHandleOutOnBottom = (leftOffsetY > rectHeight + (handleRadius / 2.0));\n\t\t\tlet rightHandleOutOnLeft = (rightOffsetX < (handleRadius / 2.0));\n\t\t\tlet rightHandleOutOnTop = (rightOffsetY < (handleRadius / 2.0));\n\t\t\tlet rightHandleOutOnRight = (rightOffsetX > rectWidth + (handleRadius / 2.0));\n\t\t\tlet rightHandleOutOnBottom = (rightOffsetY > rectHeight + (handleRadius / 2.0));\n\t\t\tlet keyOutOnLeft = (posX < -keyHalfScale);\n\t\t\tlet keyOutOnTop = (posY < -keyHalfScale);\n\t\t\tlet keyOutOnRight = (posX > rectWidth - keyHalfScale);\n\t\t\tlet keyOutOnBottom = (posY > rectHeight - keyHalfScale);\n\n\t\t\tlet allOutOnLeft = keyOutOnLeft && leftHandleOutOnLeft && rightHandleOutOnLeft;\n\t\t\tlet allOutOnTop = keyOutOnTop && leftHandleOutOnTop && rightHandleOutOnTop;\n\t\t\tlet allOutOnRight = keyOutOnRight && leftHandleOutOnRight && rightHandleOutOnRight;\n\t\t\tlet allOutOnBottom = keyOutOnBottom && leftHandleOutOnBottom && rightHandleOutOnBottom;\n\t\t\tif (allOutOnLeft || allOutOnRight || allOutOnTop || allOutOnBottom) return true;\n\t\t\treturn false;\n\t\t},\n\t\trefreshTimelineCanvas() {\n\t\t\tif (!this._isMounted) return;\n\t\t\tif (!Animation.selected) { this.clearTimelineCanvas(); return; }\n\t\t\tif (!this.animators.length || (this.graph_editor_open && !this.graph_editor_animator)) { this.clearTimelineCanvas(); return; }\n\n\t\t\t// Store stuff, yk\n\t\t\tlet size = this.size;\n\t\t\tlet scale = this.samplingScale;\n\t\t\tlet hoveredKeyframe = this.keyframeHoverUuid; \n\t\t\tlet hoveredBezierHandle = this.bezierHandleHover; \n\t\t\tlet icons = this.keyframeIcons;\n\t\t\tlet isGraph = this.graph_editor_open;\n\t\t\tlet graphOffset = this.graph_offset;\n\t\t\tlet graphSize = this.graph_size;\n\t\t\tlet graphShowAllHandles = this.show_all_handles;\n\t\t\tlet graphAxis = this.graph_editor_axis;\n\n\t\t\t// Get required elements, stop if canvas is missing, we can't draw on nothing.\n\t\t\tlet body = $('#timeline_body').get(0);\n\t\t\tlet bodyCanvas = $('#timeline_body_keyframe_canvas').get(0);\n\t\t\tlet bodyBackdrop = $('#timeline_body_keyframe_backdrop').get(0);\n\t\t\tif (!bodyCanvas) return;\n\n\t\t\t// Collect body style & scroll data\n\t\t\tlet timelineStyle = window.getComputedStyle(body);\n\t\t\tlet keyRadius = timelineStyle.getPropertyValue(\"--keyframe-radius\").trim();\n\t\t\tlet keyHoveredRadius = timelineStyle.getPropertyValue(\"--keyframe-radius-hover\").trim();\n\t\t\tlet keyGraphRadius = timelineStyle.getPropertyValue(\"--keyframe-graph-radius\").trim();\n\t\t\tlet keyGraphHoveredRadius = timelineStyle.getPropertyValue(\"--keyframe-graph-radius-hover\").trim();\n\t\t\tlet keyHiddenRadius = timelineStyle.getPropertyValue(\"--keyframe-radius-hidden\").trim();\n\t\t\tlet handleDiameter = timelineStyle.getPropertyValue(\"--keyframe-bezier-handle-diameter\").trim();\n\t\t\tlet handleStrokeWidth = timelineStyle.getPropertyValue(\"--keyframe-bezier-stroke-width\").trim();\n\t\t\tlet keyframeColor = timelineStyle.getPropertyValue(\"--color-keyframe\").trim();\n\t\t\tlet keyframeSelectedColor = timelineStyle.getPropertyValue(\"--color-keyframe-selected\").trim();\n\t\t\tlet keyframeHoveredColor = timelineStyle.getPropertyValue(\"--color-keyframe-hovered\").trim();\n\t\t\tlet keyframeCollapsedColor = timelineStyle.getPropertyValue(\"--color-keyframe-collapsed\").trim();;\n\t\t\tlet bezierHandleColor = timelineStyle.getPropertyValue(\"--color-keyframe-bezier-handle-dot\").trim();\n\t\t\tlet bezierHandleLineColor = timelineStyle.getPropertyValue(\"--color-keyframe-bezier-handle-line\").trim();\n\t\t\tlet keyHalfRadius = keyRadius / 2.0;\n\t\t\tlet keyHoveredHalfradius = keyHoveredRadius / 2.0;\n\t\t\tlet keyGraphHalfRadius = keyGraphRadius / 2.0;\n\t\t\tlet keyGraphHoveredHalfradius = keyGraphHoveredRadius / 2.0;\n\t\t\tlet keyHiddenHalfRadius = keyHiddenRadius / 2.0;\n\t\t\tlet scrollOffsetY = body.scrollTop;\n\t\t\tlet scrollOffsetX = body.scrollLeft;\n\n\t\t\t// Collect data & setup variables used for rendering only\n\t\t\tlet context = bodyCanvas.getContext(\"2d\");\n\n\t\t\t// Over-sample keyframe view, to avoid cut-off lines and odd blurs\n\t\t\tlet rectHeight = body.clientHeight;\n\t\t\tlet rectWidth = body.clientWidth - this.head_width;\n\t\t\tbodyCanvas.height = rectHeight * scale;\n\t\t\tbodyCanvas.width = rectWidth * scale;\n\t\t\tbodyCanvas.style.height = `${rectHeight}px`;\n\t\t\tbodyCanvas.style.width = `${rectWidth}px`;\n\t\t\tbodyBackdrop.style.translate = `-${rectWidth}px 0`;\n\n\t\t\tfunction drawKeyframe(keyframe, settings = { offset: 0, isCollapsed: false, isGraph: false }) {\n\t\t\t\tlet radius = settings.isGraph ? keyGraphRadius : keyRadius;\n\t\t\t\tlet halfRadius = settings.isGraph ? keyGraphHalfRadius : keyHalfRadius;\n\t\t\t\tlet hoverRadius = settings.isGraph ? keyGraphHoveredRadius : keyHoveredRadius;\n\t\t\t\tlet hoverHalfRadius = settings.isGraph ? keyGraphHoveredHalfradius : keyHoveredHalfradius;\n\n\t\t\t\tlet isHovered = (hoveredKeyframe === keyframe.uuid);\n\t\t\t\tlet anyHandleHovered = (hoveredBezierHandle.keyUuid === keyframe.uuid);\n\t\t\t\tlet keyHalfScale = settings.isCollapsed ? keyHiddenHalfRadius : ((isHovered || anyHandleHovered) ? hoverHalfRadius : halfRadius);\n\t\t\t\tlet timeStamp = keyframe.time;\n\t\t\t\tlet posX = (timeStamp * size) - (keyHalfScale - hoverHalfRadius) - scrollOffsetX;\n\t\t\t\tlet posY = settings.offset - keyHalfScale;\n\t\t\t\t\n\t\t\t\tif (settings.isGraph) {\n\t\t\t\t\tposY = graphOffset - (keyframe.display_value * graphSize) - keyHalfScale - scrollOffsetY;\n\n\t\t\t\t\t// Stop early if keyframe is out of frame\n\t\t\t\t\tif (Timeline.vue.shouldCullKeyframeOnGraph(keyframe)) return;\n\t\t\t\t}\n\t\t\t\t// Stop early if keyframe is out of frame horizontally\n\t\t\t\telse if (((posX < -keyHalfScale) || (posX > rectWidth - keyHalfScale))) return;\n\n\t\t\t\t// Set color & scale for hovering and selection\n\t\t\t\tlet isSelected = keyframe.selected;\n\t\t\t\tlet keyScale = radius * scale; // Over-sampled scale of keyframe\n\t\t\t\tlet markerColor = Timeline.vue.getColor(keyframe.color, isHovered || anyHandleHovered);\n\t\t\t\tlet color = (markerColor || keyframeColor);\n\t\t\t\tif (isSelected) {\n\t\t\t\t\t// Selection color\n\t\t\t\t\tcolor = keyframeSelectedColor;\n\t\t\t\t}\n\t\t\t\tif (isHovered || anyHandleHovered) {\n\t\t\t\t\t// Hovering scale & color (unless selected, then we use selection color) \n\t\t\t\t\tcolor = isSelected ? keyframeSelectedColor : (markerColor || keyframeHoveredColor);\n\t\t\t\t\tkeyScale = hoverRadius * scale;\n\t\t\t\t}\n\t\t\t\tif (settings.isCollapsed) {\n\t\t\t\t\t// Hidden scale & color \n\t\t\t\t\tcolor = keyframeCollapsedColor\n\t\t\t\t\tkeyScale = keyHiddenRadius * scale;\n\t\t\t\t};\n\n\t\t\t\tfunction pickIcon(iconData, continuousOnly = false) {\n\t\t\t\t\tlet data = iconData;\n\t\t\t\t\tif (settings.isCollapsed) data = icons.hidden;\n\n\t\t\t\t\tif (continuousOnly) {\n\t\t\t\t\t\tif (isMolang) return data.molang;\n\t\t\t\t\t\telse return data.default;\n\t\t\t\t\t}\n\n\t\t\t\t\tif (isMolang && !isContinuous && !settings.isCollapsed) return data.discontinuous_molang;\n\t\t\t\t\telse if (isMolang) return data.molang;\n\t\t\t\t\telse if (!isContinuous) return data.discontinuous;\n\t\t\t\t\telse return data.default;\n\t\t\t\t} \n\n\t\t\t\tlet txtPosition = [(posX * scale), (posY * scale)];\n\t\t\t\tlet icon = \"\";\n\t\t\t\tlet isMolang = keyframe.has_expressions;\n\t\t\t\tlet isContinuous = keyframe.data_points?.length == 1 || false;\n\t\t\t\tswitch (keyframe.interpolation) {\n\t\t\t\t\tcase \"step\": { \n\t\t\t\t\t\ticon = pickIcon(icons.step);\n\t\t\t\t\t\tbreak; \n\t\t\t\t\t}\n\t\t\t\t\tcase \"bezier\": { \n\t\t\t\t\t\ticon = pickIcon(settings.isGraph ? icons.linear : icons.bezier);\n\t\t\t\t\t\tbreak; \n\t\t\t\t\t}\n\t\t\t\t\tcase \"catmullrom\": { \n\t\t\t\t\t\ticon = pickIcon(icons.smooth, true);\n\t\t\t\t\t\tbreak; \n\t\t\t\t\t}\n\t\t\t\t\tdefault: { \n\t\t\t\t\t\ticon = pickIcon(icons.linear);\n\t\t\t\t\t\tbreak; \n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\tif (settings.isGraph) {\n\t\t\t\t\tlet displayHandles = (keyframe.interpolation == \"bezier\") && (graphShowAllHandles || keyframe.selected);\n\n\t\t\t\t\tif (displayHandles) {\n\t\t\t\t\t\t// Get keyframe X and Y without the text box offset\n\t\t\t\t\t\tlet keyX = (timeStamp * size) + halfRadius - scrollOffsetX;\n\t\t\t\t\t\tlet keyY = graphOffset - (keyframe.display_value * graphSize) - scrollOffsetY;\n\n\t\t\t\t\t\t// Handle position info\n\t\t\t\t\t\tlet axis = getAxisNumber(graphAxis);\n\t\t\t\t\t\tlet leftOffsetX = (keyframe[`bezier_left_time`][axis] * size) + keyX;\n\t\t\t\t\t\tlet rightOffsetX = (keyframe[`bezier_right_time`][axis] * size) + keyX;\n\t\t\t\t\t\tlet leftOffsetY = (-keyframe[`bezier_left_value`][axis] * graphSize) + keyY;\n\t\t\t\t\t\tlet rightOffsetY = (-keyframe[`bezier_right_value`][axis] * graphSize) + keyY;\n\t\t\t\t\t\tlet handleRadius = handleDiameter / 2.0;\n\n\t\t\t\t\t\t// Hover data\n\t\t\t\t\t\tlet canBeHovered = hoveredBezierHandle.keyUuid === keyframe.uuid;\n\t\t\t\t\t\tlet isLeftHovered = hoveredBezierHandle.side === \"left\" && canBeHovered;\n\t\t\t\t\t\tlet isRightHovered = hoveredBezierHandle.side === \"right\" && canBeHovered;\n\n\t\t\t\t\t\tcontext.lineWidth = handleStrokeWidth * scale;\n\t\t\t\t\t\t\n\t\t\t\t\t\t// Left bezier\n\t\t\t\t\t\tcontext.strokeStyle = (isLeftHovered || isHovered) ? keyframeSelectedColor : bezierHandleLineColor;\n\t\t\t\t\t\tcontext.beginPath(); // Handle line start\n\t\t\t\t\t\tcontext.moveTo(keyX * scale, keyY * scale);\n\t\t\t\t\t\tcontext.lineTo(leftOffsetX * scale, leftOffsetY * scale);\n\t\t\t\t\t\tcontext.stroke();\n\t\t\t\t\t\tcontext.closePath();\n\t\t\t\t\t\tcontext.strokeStyle = (isLeftHovered || isHovered) ? keyframeSelectedColor : keyframeColor;\n\t\t\t\t\t\tcontext.fillStyle = bezierHandleColor;\n\t\t\t\t\t\tcontext.beginPath(); // Handle dot start\n\t\t\t\t\t\tcontext.arc(leftOffsetX * scale, leftOffsetY * scale, handleRadius * scale, 0, 2 * Math.PI);\n\t\t\t\t\t\tcontext.fill();\n\t\t\t\t\t\tcontext.stroke();\n\t\t\t\t\t\tcontext.closePath();\n\n\t\t\t\t\t\t// Right bezier\n\t\t\t\t\t\tcontext.strokeStyle = (isRightHovered || isHovered) ? keyframeSelectedColor : bezierHandleLineColor;\n\t\t\t\t\t\tcontext.beginPath(); // Handle line start\n\t\t\t\t\t\tcontext.moveTo(keyX * scale, keyY * scale);\n\t\t\t\t\t\tcontext.lineTo(rightOffsetX * scale, rightOffsetY * scale);\n\t\t\t\t\t\tcontext.stroke();\n\t\t\t\t\t\tcontext.closePath();\n\t\t\t\t\t\tcontext.strokeStyle = (isRightHovered || isHovered) ? keyframeSelectedColor : keyframeColor;\n\t\t\t\t\t\tcontext.fillStyle = bezierHandleColor;\n\t\t\t\t\t\tcontext.beginPath(); // Handle dot start\n\t\t\t\t\t\tcontext.arc(rightOffsetX * scale, rightOffsetY * scale, handleRadius * scale, 0, 2 * Math.PI);\n\t\t\t\t\t\tcontext.fill();\n\t\t\t\t\t\tcontext.stroke();\n\t\t\t\t\t\tcontext.closePath();\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\tcontext.font = `${keyScale}px icomoon`;\n\t\t\t\tcontext.fillStyle = color;\n\t\t\t\tcontext.textBaseline  = \"top\"; // Top as if it were images, starting at (0, 0) (left, top)\n\t\t\t\tcontext.fillText(icon, txtPosition[0], txtPosition[1]);\n\t\t\t}\n\n\t\t\t// re-draw keyframes.\n\t\t\tthis.clearTimelineCanvas();\n\t\t\tif (isGraph) {\n\t\t\t\tlet keyframes = this.graph_editor_animator[this.graph_editor_channel];\n\t\t\t\tfor (let keyframe of keyframes) {\n\t\t\t\t\tdrawKeyframe(keyframe, { isGraph: true });\n\t\t\t\t}\n\t\t\t}\n\t\t\telse {\n\t\t\t\tlet channelHeight = timelineStyle.getPropertyValue(\"--timeline-channel-height\").trim();\n\t\t\t\tlet channelHalfHeight = channelHeight / 2.0;\n\t\t\t\tlet heightAccumulator = 0;\n\n\t\t\t\tfor (let i = 0; i < this.animators.length; i++) {\n\t\t\t\t\tlet animator = this.animators[i];\n\t\t\t\t\tlet channelKeys = Object.keys(animator.channels);\n\t\t\t\t\tlet animatorY = channelHeight * heightAccumulator - scrollOffsetY;\n\t\t\t\t\theightAccumulator++;\n\n\t\t\t\t\tfor (let j = 0; j < channelKeys.length; j++) {\n\t\t\t\t\t\tlet channel = channelKeys[j];\n\t\t\t\t\t\tlet channelOptions = animator.channels[channel];\n\n\t\t\t\t\t\t// Stop early if channel should be hidden\n\t\t\t\t\t\tlet channelExists = this.channels[channel] != false;\n\t\t\t\t\t\tlet isConditionMet = Condition(channelOptions.condition, animator);\n\t\t\t\t\t\tlet canShow = (!this.channels.hide_empty || animator[channel].length);\n\t\t\t\t\t\tlet isExpanded = animator.expanded && channelExists && canShow\n\t\t\t\t\t\tif (!(isExpanded || isConditionMet)) continue;\n\n\t\t\t\t\t\t// Get our remaining data\n\t\t\t\t\t\tlet channelY = channelHeight * heightAccumulator - scrollOffsetY;\n\t\t\t\t\t\tif (!isExpanded) channelY = animatorY;\n\t\t\t\t\t\telse if (isConditionMet) heightAccumulator++; // Add to total channel height stack if this channel is able to display\n\n\t\t\t\t\t\t// Stop early if channel is out of frame vertically\n\t\t\t\t\t\tif (channelY < -channelHalfHeight) continue;\n\t\t\t\t\t\tif (channelY > rectHeight - channelHalfHeight) break;\n\n\t\t\t\t\t\tlet keyframes = animator[channel];\n\t\t\t\t\t\tfor (let keyframe of keyframes) {\n\t\t\t\t\t\t\tdrawKeyframe(keyframe, { offset: channelY + channelHalfHeight, isCollapsed: !isExpanded });\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t},\n\t\ttryGetKeyframeClosestToMouse(event) {\n\t\t\tlet body = $('#timeline_body').get(0);\n\t\t\tlet bodyCanvas = $('#timeline_body_keyframe_canvas').get(0);\n\t\t\tlet timelineStyle = window.getComputedStyle(body);\n\t\t\tlet keyRadius = timelineStyle.getPropertyValue(\"--keyframe-radius\").trim();\n\t\t\tlet keyGraphRadius = timelineStyle.getPropertyValue(\"--keyframe-graph-radius\").trim();\n\t\t\tlet channelHeight = timelineStyle.getPropertyValue(\"--timeline-channel-height\").trim();\n\n\t\t\t// Mouse position\n    \t\tlet rect = bodyCanvas.getBoundingClientRect();\n\t\t    let x = event.pageX - rect.left;\n\t\t    let y = event.pageY - rect.top;\n\t\t\tlet mouseVec = [x, y];\n\n\t\t\t// Dom info\n\t\t\tlet size = this.size;\n\t\t\tlet graphSize = this.graph_size;\n\t\t\tlet channelHalfHeight = channelHeight / 2.0;\n\t\t\tlet keyHalfRadius = keyRadius / 2.0;\n\t\t\tlet keyGraphHalfRadius = keyGraphRadius / 2.0;\n\t\t\tlet rectHeight = body.clientHeight;\n\t\t\tlet rectWidth = body.clientWidth - this.head_width;\n\t\t\tlet scrollOffsetY = body.scrollTop;\n\t\t\tlet scrollOffsetX = body.scrollLeft;\n\n\t\t\t// Find closest keyframe to mouse\n\t\t\tlet shortestDist = Infinity;\n\t\t\tlet shortestUuid = \"\";\n\t\t\tlet shortestHandle = \"\";\n\t\t\tif (this.graph_editor_open) {\n\t\t\t\tif (!this.graph_editor_animator) return;\n\n\t\t\t\tlet keyframes = this.graph_editor_animator[this.graph_editor_channel];\n\t\t\t\tfor (let keyframe of keyframes) {\n\t\t\t\t\t// Key position\n\t\t\t\t\tlet posX = (keyframe.time * size) + keyGraphHalfRadius - scrollOffsetX;\n\t\t\t\t\tlet posY = this.graph_offset - (keyframe.display_value * graphSize) - channelHalfHeight - scrollOffsetY;\n\t\t\t\t\n\t\t\t\t\t// Stop early if keyframe is out of frame\n\t\t\t\t\tif (this.shouldCullKeyframeOnGraph(keyframe)) continue;\n\n\t\t\t\t\t// Handle positions\n\t\t\t\t\tlet axis = getAxisNumber(this.graph_editor_axis);\n\t\t\t\t\tlet leftOffsetX = keyframe[`bezier_left_time`][axis] * size;\n\t\t\t\t\tlet leftOffsetY = -keyframe[`bezier_left_value`][axis] * graphSize;\n\t\t\t\t\tlet rightOffsetX = keyframe[`bezier_right_time`][axis] * size;\n\t\t\t\t\tlet rightOffsetY = -keyframe[`bezier_right_value`][axis] * graphSize;\n\n\t\t\t\t\tif (keyframe.interpolation === \"bezier\") {\n\t\t\t\t\t\tlet leftHandleVec = [leftOffsetX, leftOffsetY].V2_add([posX, posY]);\n\t\t\t\t\t\tlet rightHandleVec = [rightOffsetX, rightOffsetY].V2_add([posX, posY]);\n\t\t\t\t\t\tlet distanceToLeft = [...mouseVec].V2_subtract(leftHandleVec).V2_toThree().length();\n\t\t\t\t\t\tlet distanceToRight = [...mouseVec].V2_subtract(rightHandleVec).V2_toThree().length();\n\n\t\t\t\t\t\tif (distanceToLeft < shortestDist) {\n\t\t\t\t\t\t\tshortestDist = distanceToLeft;\n\t\t\t\t\t\t\tshortestUuid = keyframe.uuid;\n\t\t\t\t\t\t\tshortestHandle = \"left\";\n\t\t\t\t\t\t}\n\t\t\t\t\t\tif (distanceToRight < shortestDist) {\n\t\t\t\t\t\t\tshortestDist = distanceToRight;\n\t\t\t\t\t\t\tshortestUuid = keyframe.uuid;\n\t\t\t\t\t\t\tshortestHandle = \"right\";\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\tlet keyframeVec = [posX, posY].V2_add([keyGraphHalfRadius, keyGraphHalfRadius]);\n\t\t\t\t\tlet distanceToKey = [...mouseVec].V2_subtract(keyframeVec).V2_toThree().length();\n\t\t\t\t\tif (distanceToKey < shortestDist) {\n\t\t\t\t\t\tshortestDist = distanceToKey;\n\t\t\t\t\t\tshortestUuid = keyframe.uuid;\n\t\t\t\t\t\tshortestHandle = \"\";\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\telse {\n\t\t\t\tlet heightAccumulator = 0;\n\t\t\t\tfor (let i = 0; i < this.animators.length; i++) {\n\t\t\t\t\tlet animator = this.animators[i];\n\t\t\t\t\tlet channelKeys = Object.keys(animator.channels);\n\t\t\t\t\theightAccumulator++;\n\n\t\t\t\t\tfor (let j = 0; j < channelKeys.length; j++) {\n\t\t\t\t\t\tlet channel = channelKeys[j];\n\t\t\t\t\t\tlet channelOptions = animator.channels[channel];\n\n\t\t\t\t\t\t// Stop early if channel should be hidden\n\t\t\t\t\t\tlet isExpanded = animator.expanded;\n\t\t\t\t\t\tlet channelExists = this.channels[channel] != false;\n\t\t\t\t\t\tlet isConditionMet = Condition(channelOptions.condition, animator);\n\t\t\t\t\t\tlet canShow = (!this.channels.hide_empty || animator[channel].length);\n\t\t\t\t\t\tif (!(isExpanded && channelExists && isConditionMet && canShow)) continue; // This channel is not displayed atm, so we can stop.\n\n\t\t\t\t\t\t// Get our remaining data\n\t\t\t\t\t\tlet channelY = channelHeight * heightAccumulator - scrollOffsetY;\n\t\t\t\t\t\theightAccumulator++;\n\n\t\t\t\t\t\t// Stop early if channel is out of frame vertically\n\t\t\t\t\t\tif (channelY < -channelHalfHeight) continue;\n\t\t\t\t\t\tif (channelY > rectHeight - channelHalfHeight) break;\n\n\t\t\t\t\t\tlet keyframes = animator[channel];\n\t\t\t\t\t\tfor (let keyframe of keyframes) {\n\t\t\t\t\t\t\tlet posX = (keyframe.time * size) - scrollOffsetX;\n\t\t\t\t\t\t\tlet posY = channelY + channelHalfHeight - keyHalfRadius;\n\n\t\t\t\t\t\t\t// Stop early if keyframe is out of frame horizontally\n\t\t\t\t\t\t\tif ((posX < -keyHalfRadius) || (posX > rectWidth - keyHalfRadius)) continue;\n\n\t\t\t\t\t\t\tlet keyframeVec = [posX, posY].V2_add([keyHalfRadius, keyHalfRadius / 4.0]); // unsure why I divided by 4 here, but it works\n\t\t\t\t\t\t\tlet distance = [...mouseVec].V2_subtract(keyframeVec).V2_toThree().length();\n\t\t\t\t\t\t\tif (distance < shortestDist) {\n\t\t\t\t\t\t\t\tshortestDist = distance;\n\t\t\t\t\t\t\t\tshortestUuid = keyframe.uuid;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t// Check if our closest keyframe is within the selection radius before we return it\n\t\t\tlet closestKeyframe = Timeline.keyframes.find(keyframe => keyframe.uuid === shortestUuid);\n\t\t\tlet trueRadius = this.graph_editor_open ? keyGraphRadius : keyRadius;\n\t\t\tif (shortestDist < trueRadius) {\n\t\t\t\tif (shortestHandle !== \"\") {\n\t\t\t\t\treturn {\n\t\t\t\t\t\ttarget: closestKeyframe,\n\t\t\t\t\t\thandle: shortestHandle,\n\t\t\t\t\t\ttype: \"bezier_handle\"\n\t\t\t\t\t};\n\t\t\t\t}\n\n\t\t\t\treturn {\n\t\t\t\t\ttarget: closestKeyframe,\n\t\t\t\t\ttype: \"keyframe\"\n\t\t\t\t};\n\t\t\t}\n\t\t\t\n\t\t\treturn { type: \"fail\" };\n\t\t\t// console.log(`[${[x, y]}], ${shortestDist}, ${shortestUuid}`);\n\t\t},\n\t\tgetKeyframeFromUuid(uuid) {\n\t\t\tif (uuid === \"\") return false;\n\n\t\t\tfor (let animator of this.animators) {\n\t\t\t\tfor (let channel of Object.keys(animator.channels)) {\n\t\t\t\t\tfor (let keyframe of animator[channel]) {\n\t\t\t\t\t\tif (keyframe.uuid === uuid) return keyframe;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\treturn false;\n\t\t},\n\t\tclickKeyframeOnCanvas(event) {\n\t\t\tlet keyframe = this.getKeyframeFromUuid(this.keyframeHoverUuid);\n\t\t\tif (!keyframe) return;\n\t\t\tif (Timeline.selector.selecting) return;\n\t\t\tkeyframe.clickSelect(event);\n\t\t\tthis.refreshTimelineCanvas();\n\t\t},\n\t\tcallPlayHeadToKeyframeOnCanvas(event) {\n\t\t\tlet keyframe = this.getKeyframeFromUuid(this.keyframeHoverUuid);\n\t\t\tif (!keyframe) return;\n\t\t\tkeyframe.callPlayhead();\n\t\t},\n\t\tdragOnCanvas(event) {\n\t\t\tlet keyframe = this.getKeyframeFromUuid(this.keyframeHoverUuid);\n\t\t\tif (!keyframe) {\n\t\t\t\tif (this.bezierHandleHover.keyUuid !== \"\") {\n\t\t\t\t\tkeyframe = this.getKeyframeFromUuid(this.bezierHandleHover.keyUuid);\n\t\t\t\t\tevent.stopPropagation();\n\t\t\t\t\tthis.dragBezierHandle(keyframe, this.bezierHandleHover.side, event);\n\t\t\t\t}\n\t\t\t\treturn;\n\t\t\t}\n\t\t\tevent.stopPropagation();\n\t\t\tthis.dragKeyframes(keyframe, event);\n\t\t},\n\t\topenKeyframeContextMenuOnCanvas(event) {\n\t\t\tlet keyframe = this.getKeyframeFromUuid(this.keyframeHoverUuid);\n\t\t\tif (!keyframe) {\n\t\t\t\tthis.openContextMenu(event);\n\t\t\t\treturn;\n\t\t\t}\n\t\t\tkeyframe.showContextMenu(event);\n\t\t},\n\t\thoverOnCanvas(event) {\n\t\t\tif (Timeline.selector.selecting) return;\n\t\t\tlet result = this.tryGetKeyframeClosestToMouse(event);\n\t\t\tif (!result) return;\n\n\t\t\tswitch (result.type) {\n\t\t\t\tcase \"keyframe\": {\n\t\t\t\t\tif (!result.target) break;\n\t\t\t\t\tif (result.target.uuid === this.keyframeHoverUuid) break;\n\n\t\t\t\t\t// Make sure no handle is accidentally hovered\n\t\t\t\t\tif (this.bezierHandleHover.keyUuid !== \"\") {\n\t\t\t\t\t\tthis.bezierHandleHover.keyUuid = \"\";\n\t\t\t\t\t\tthis.bezierHandleHover.side = \"\";\n\t\t\t\t\t}\n\n\t\t\t\t\tthis.keyframeHoverUuid = result.target.uuid;\n\t\t\t\t\tthis.refreshTimelineCanvas();\n\t\t\t\t\tbreak;\n\t\t\t\t}\n\t\t\t\tcase \"bezier_handle\": {\n\t\t\t\t\tif (!result.target) break;\n\t\t\t\t\tif (result.target.uuid === this.bezierHandleHover.keyUuid) break;\n\t\t\t\t\t\n\t\t\t\t\t// Make sure no keyframe is accidentally hovered\n\t\t\t\t\tif (this.keyframeHoverUuid !== \"\") {\n\t\t\t\t\t\tthis.keyframeHoverUuid = \"\";\n\t\t\t\t\t}\n\n\t\t\t\t\tthis.bezierHandleHover.keyUuid = result.target.uuid;\n\t\t\t\t\tthis.bezierHandleHover.side = result.handle;\n\t\t\t\t\tthis.refreshTimelineCanvas();\n\t\t\t\t\tbreak;\n\t\t\t\t\t// console.log(`hitting handle on the ${result.handle} of key at ${result.target.time}`)\n\t\t\t\t}\n\t\t\t\tcase \"fail\": {\n\t\t\t\t\tif (this.keyframeHoverUuid !== \"\" || this.bezierHandleHover.keyUuid !== \"\") {\n\t\t\t\t\t\tthis.keyframeHoverUuid = \"\";\n\t\t\t\t\t\tthis.bezierHandleHover.keyUuid = \"\";\n\t\t\t\t\t\tthis.bezierHandleHover.side = \"\";\n\t\t\t\t\t\tthis.refreshTimelineCanvas();\n\t\t\t\t\t}\n\t\t\t\t\tbreak;\n\t\t\t\t}\n\t\t\t}\n\t\t},\n\t\tclearHoveredKeyframe() {\n\t\t\tthis.keyframeHoverUuid = \"\";\n\t\t\tthis.refreshTimelineCanvas();\n\t\t},\n\t\teventTargetToAnimator(target) {\n\t\t\tlet target_node = target;\n\t\t\tlet i = 0;\n\t\t\twhile (target_node && target_node.classList && !target_node.classList.contains('animator')) {\n\t\t\t\tif (i < 3 && target_node) {\n\t\t\t\t\ttarget_node = target_node.parentNode;\n\t\t\t\t\ti++;\n\t\t\t\t} else {\n\t\t\t\t\treturn [];\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn [this.animators.find(animator => animator.uuid == target_node.attributes.uuid.value), target_node];\n\t\t},\n\t\tupdateTimecodes() {\n\t\t\tif (!this._isMounted) return;\n\t\t\tthis.timecodes.empty();\n\t\t\tlet timeline_container_width = Panels.timeline.node.clientWidth - this.head_width;\n\t\t\tthis.length = Timeline.getMaxLength();\n\n\t\t\tvar step = 1\n\t\t\tif (this.size < 1) {step = 1}\n\t\t\telse if (this.size < 20) {step = 4}\n\t\t\telse if (this.size < 40) {step = 2}\n\t\t\telse if (this.size < 100) {step = 1}\n\t\t\telse if (this.size < 256) {step = 0.5}\n\t\t\telse if (this.size < 520) {step = 0.25}\n\t\t\telse if (this.size < 660) {step = 0.2}\n\t\t\telse if (this.size < 860) {step = 0.1}\n\t\t\telse {step = 0.05}\n\n\t\t\t// Rounding to \"FPS\" to better match snapping\n\t\t\tif (step < 1) {\n\t\t\t\tlet substep_simplification = Math.max((Math.floor(Math.sqrt(step / Timeline.getStep()))-1), 1);\n\t\t\t\tvar FPS = Timeline.getStep() / substep_simplification;\n\t\t\t\tstep = Math.round(step/FPS) * FPS\n\t\t\t}\n\n\t\t\t// Substep simplification\n\t\t\tlet substeps = step / Timeline.getStep()\n\t\t\twhile (substeps > 8) {\n\t\t\t\tsubsteps /= 2;\n\t\t\t}\n\t\t\t\n\t\t\t// Generate\n\t\t\tvar i = Math.floor(this.scroll_left / this.size / step) * step;\n\t\t\twhile (i < Math.ceil((this.scroll_left + timeline_container_width) / this.size / step) * step) {\n\t\t\t\tif (settings.timecode_frame_number.value) {\n\t\t\t\t\tvar text = Math.round(i / Timeline.getStep());\n\t\t\t\t} else {\n\t\t\t\t\tvar text = Math.round(i*100)/100;\n\t\t\t\t}\n\t\t\t\tthis.timecodes.push({\n\t\t\t\t\ttime: i,\n\t\t\t\t\twidth: step,\n\t\t\t\t\tsubsteps,\n\t\t\t\t\ttext,\n\t\t\t\t})\n\t\t\t\ti += step;\n\t\t\t}\n\n\t\t\tif (this.graph_editor_open) {\n\t\t\t\tthis.graph_size += 1e-5;\n\t\t\t}\n\t\t},\n\t\tupdateGraph() {\n\t\t\tif (this.graph_editor_open) {\n\t\t\t\tthis.graph_size += 1e-7;\n\t\t\t}\n\t\t},\n\t\ttoggleAnimator(animator) {\n\t\t\tanimator.expanded = !animator.expanded;\n\t\t\tthis.refreshTimelineCanvas();\n\t\t},\n\t\tremoveAnimator(animator) {\n\t\t\tTimeline.animators.remove(animator);\n\n\t\t\tif (Timeline.animators.length ===0) {\n\t\t\t\tthis.clearTimelineCanvas();\n\t\t\t}\n\t\t},\n\t\ttoggleGlobalSpace(animator) {\n\t\t\tUndo.initEdit({animations: [Animation.selected]});\n\t\t\tanimator.rotation_global = !animator.rotation_global;\n\t\t\tUndo.finishEdit('Toggle rotation in global space');\n\t\t\tAnimator.preview();\n\t\t},\n\t\tselectChannel(animator, channel) {\n\t\t\tif (this.graph_editor_channel == channel && animator.selected) return;\n\t\t\tif (!animator.channels[channel].transform) return;\n\t\t\tUndo.initSelection();\n\t\t\tif (!animator.selected) animator.select();\n\t\t\t// Select keyframe in new channel\n\t\t\tif (animator[channel].length && Keyframe.selected.length > 0) {\n\t\t\t\tif (animator[channel].length == 1 && Math.epsilon(animator[channel][0].time, Timeline.time, 0.002)) {\n\t\t\t\t\tanimator[channel][0].select();\n\t\t\t\t} else if (animator[channel].find(kf => Math.epsilon(kf.time, Keyframe.selected[0].time))) {\n\t\t\t\t\tlet kf = animator[channel].find(kf => Math.epsilon(kf.time, Keyframe.selected[0].time, 0.002));\n\t\t\t\t\tkf.select();\n\t\t\t\t} else {\n\t\t\t\t\tlet kf = animator[channel].slice().sort((a, b) => Math.abs(a.time - Timeline.time) - Math.abs(b.time - Timeline.time))[0];\n\t\t\t\t\tkf.select();\n\t\t\t\t}\n\t\t\t}\n\t\t\tthis.graph_editor_channel = channel;\n\t\t\tUndo.finishSelection('Select animation channel');\n\t\t},\n\t\tgetColor(index, pastel = false) {\n\t\t\tif (index == -1 || index == undefined) return;\n\t\t\tlet color = markerColors[index % markerColors.length];\n\t\t\treturn pastel ? color.pastel : color.standard;\n\t\t},\n\t\tgetWaveformPoints(samples, size) {\n\t\t\tlet height = 23;\n\t\t\tlet points = [`0,${height}`];\n\t\t\tsamples.forEach((sample, i) => {\n\t\t\t\tpoints.push(`${(i + 0.5) / Timeline.waveform_sample_rate * size},${(1 - sample) * height}`);\n\t\t\t})\n\t\t\tpoints.push(`${(samples.length) / Timeline.waveform_sample_rate * size},${height}`)\n\t\t\treturn points.join(' ');\n\t\t},\n\t\tupdateScroll() {\n\t\t\tthis.scroll_left = this.$refs.timeline_body ? this.$refs.timeline_body.scrollLeft : 0;\n\t\t\tthis.scroll_top = this.$refs.timeline_body ? this.$refs.timeline_body.scrollTop : 0;\n\t\t\tthis.refreshTimelineCanvas();\n\t\t},\n\t\topenContextMenu(event) {\n\t\t\tif (event.target.nodeName == 'KEYFRAME' || event.target.parentElement.nodeName == 'KEYFRAME') return;\n\t\t\tif (Blockbench.hasFlag('no_context_menu')) return;\n\t\t\tevent.preventDefault();\n\t\t\tTimeline.menu.open(event, event);\n\t\t},\n\t\tdragAnimator(animator, e1) {\n\t\t\tif (getFocusedTextInput()) return;\n\t\t\tif (e1.button == 1 || e1.button == 2) return;\n\t\t\tconvertTouchEvent(e1);\n\n\t\t\tlet active = false;\n\t\t\tlet helper;\n\t\t\tlet timeout;\n\t\t\tlet drop_target, drop_target_node, order;\n\t\t\tlet last_event = e1;\n\n\t\t\tfunction move(e2) {\n\t\t\t\tconvertTouchEvent(e2);\n\t\t\t\tlet offset = [\n\t\t\t\t\te2.clientX - e1.clientX,\n\t\t\t\t\te2.clientY - e1.clientY,\n\t\t\t\t]\n\t\t\t\tif (!active) {\n\t\t\t\t\tlet distance = Math.sqrt(Math.pow(offset[0], 2) + Math.pow(offset[1], 2))\n\t\t\t\t\tif (Blockbench.isTouch) {\n\t\t\t\t\t\tif (distance > 20 && timeout) {\n\t\t\t\t\t\t\tclearTimeout(timeout);\n\t\t\t\t\t\t\ttimeout = null;\n\t\t\t\t\t\t} else {\n\t\t\t\t\t\t\tdocument.getElementById('timeline_body_inner').scrollTop += last_event.clientY - e2.clientY;\n\t\t\t\t\t\t}\n\t\t\t\t\t} else if (distance > 6) {\n\t\t\t\t\t\tactive = true;\n\t\t\t\t\t\tUndo.initSelection();\n\t\t\t\t\t}\n\t\t\t\t} else {\n\t\t\t\t\tif (e2) e2.preventDefault();\n\t\t\t\t\t\n\t\t\t\t\tif (Menu.open) Menu.open.hide();\n\n\t\t\t\t\tif (!helper) {\n\t\t\t\t\t\thelper = document.createElement('div');\n\t\t\t\t\t\thelper.id = 'animation_drag_helper';\n\t\t\t\t\t\tlet icon = document.createElement('i');\t\ticon.className = 'material-icons'; icon.innerText = 'chevron_right'; helper.append(icon);\n\t\t\t\t\t\tlet span = document.createElement('span');\tspan.innerText = animator.name;\thelper.append(span);\n\t\t\t\t\t\tdocument.body.append(helper);\n\t\t\t\t\t}\n\t\t\t\t\thelper.style.left = `${e2.clientX}px`;\n\t\t\t\t\thelper.style.top = `${e2.clientY}px`;\n\n\t\t\t\t\t// drag\n\t\t\t\t\t$('.drag_hover').removeClass('drag_hover');\n\t\t\t\t\t$('.animator[order]').attr('order', null);\n\n\t\t\t\t\tlet target = document.elementFromPoint(e2.clientX, e2.clientY);\n\t\t\t\t\t[drop_target, drop_target_node] = eventTargetToAnimator(target);\n\t\t\t\t\tif (drop_target) {\n\t\t\t\t\t\tlet location = e2.clientY - $(drop_target_node).offset().top;\n\t\t\t\t\t\tlet half_height = drop_target_node.clientHeight/2;\n\t\t\t\t\t\tlet order = location <= half_height ? -1 : 1;\n\t\t\t\t\t\tdrop_target_node.setAttribute('order', order)\n\t\t\t\t\t\tdrop_target_node.classList.add('drag_hover');\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tlast_event = e2;\n\t\t\t\tTimeline.vue.refreshTimelineCanvas();\n\t\t\t}\n\t\t\tfunction off(e2) {\n\t\t\t\tif (helper) helper.remove();\n\t\t\t\tremoveEventListeners(document, 'mousemove touchmove', move);\n\t\t\t\tremoveEventListeners(document, 'mouseup touchend', off);\n\t\t\t\t$('.drag_hover').removeClass('drag_hover');\n\t\t\t\t$('.animator[order]').attr('order', null);\n\t\t\t\tif (Blockbench.isTouch) clearTimeout(timeout);\n\n\t\t\t\tif (active && !open_menu) {\n\t\t\t\t\tconvertTouchEvent(e2);\n\t\t\t\t\tlet target = document.elementFromPoint(e2.clientX, e2.clientY);\n\t\t\t\t\tlet [target_animator] = eventTargetToAnimator(target);\n\t\t\t\t\tif (!target_animator || target_animator == animator ) return;\n\t\t\t\t\t\n\t\t\t\t\tlet index = Timeline.animators.indexOf(target_animator);\n\t\t\t\t\tif (index == -1) return;\n\t\t\t\t\tif (order == 1) index++;\n\t\t\t\t\tif (Timeline.animators[index] == animator) return;\n\t\t\t\t\tTimeline.animators.remove(animator);\n\t\t\t\t\tTimeline.animators.splice(index, 0, animator);\n\t\t\t\t\tUndo.finishSelection('Rearrange animators in timeline');\n\t\t\t\t\tTimeline.vue.refreshTimelineCanvas();\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tif (Blockbench.isTouch) {\n\t\t\t\ttimeout = setTimeout(() => {\n\t\t\t\t\tactive = true;\n\t\t\t\t\tmove(e1);\n\t\t\t\t}, 320)\n\t\t\t}\n\n\t\t\taddEventListeners(document, 'mousemove touchmove', move, {passive: false});\n\t\t\taddEventListeners(document, 'mouseup touchend', off, {passive: false});\n\t\t},\n\t\tdragKeyframes(clicked, e1) {\n\t\t\tif (e1.target.classList.contains('keyframe_bezier_handle')) return;\n\t\t\tif (e1.button > 0) return;\n\t\t\tconvertTouchEvent(e1);\n\t\t\tlet dragging_range;\n\t\t\tlet dragging_restriction;\n\t\t\tlet originalValue;\n\t\t\tlet previousValue;\n\t\t\tlet time_stretching;\n\t\t\tlet values_changed;\n\t\t\tlet is_setup = false;\n\t\t\tlet old_bezier_values = {};\n\t\t\tlet scope = this;\n\n\t\t\tfunction setup() {\n\t\t\t\tdragging_range = [Infinity, 0];\n\t\t\t\tdragging_restriction;\n\t\t\t\toriginalValue;\n\t\t\t\tpreviousValue = 0;\n\t\t\t\ttime_stretching = !Timeline.vue.graph_editor_open && (e1.ctrlOrCmd || Pressing.overrides.ctrl) && Timeline.selected.length > 1;\n\t\t\t\tvalues_changed = false;\n\n\t\t\t\tif (!clicked.selected && !e1.shiftKey && !Pressing.overrides.shift && Timeline.selected.length != 0) {\n\t\t\t\t\tclicked.select()\n\t\t\t\t} else if (clicked && !clicked.selected) {\n\t\t\t\t\tclicked.select({shiftKey: true})\n\t\t\t\t}\n\n\t\t\t\tUndo.initEdit({keyframes: Timeline.selected});\n\t\t\t\tTimeline.dragging_keyframes = true;\n\n\t\t\t\tfor (var kf of Timeline.selected) {\n\t\t\t\t\tkf.time_before = kf.time;\n\t\t\t\t\tdragging_range[0] = Math.min(dragging_range[0], kf.time);\n\t\t\t\t\tdragging_range[1] = Math.max(dragging_range[1], kf.time);\n\t\t\t\t\told_bezier_values[kf.uuid] = {\n\t\t\t\t\t\tleft: kf.bezier_left_time.slice(),\n\t\t\t\t\t\tright: kf.bezier_right_time.slice(),\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\tif (Timeline.vue.graph_editor_open) {\n\t\t\t\t\t// Find dragging restriction\n\t\t\t\t\tdragging_restriction = [-Infinity, Infinity];\n\t\t\t\t\tlet ba = scope.graph_editor_animator || 0;\n\t\t\t\t\tlet all_keyframes = ba[scope.graph_editor_channel];\n\t\t\t\t\tif (all_keyframes) {\n\n\t\t\t\t\t\tlet frst_keyframe;\n\t\t\t\t\t\tlet last_keyframe;\n\t\t\t\t\t\tTimeline.selected.forEach(kf => {\n\t\t\t\t\t\t\tif (!frst_keyframe || frst_keyframe.time > kf.time) frst_keyframe = kf;\n\t\t\t\t\t\t\tif (!last_keyframe || last_keyframe.time < kf.time) last_keyframe = kf;\n\t\t\t\t\t\t})\n\t\t\t\t\t\tlet prvs_keyframe;\n\t\t\t\t\t\tlet next_keyframe;\n\t\t\t\t\t\tall_keyframes.forEach(kf => {\n\t\t\t\t\t\t\tif (kf.time < frst_keyframe.time && (!prvs_keyframe || prvs_keyframe.time < kf.time)) prvs_keyframe = kf;\n\t\t\t\t\t\t\tif (kf.time > last_keyframe.time && (!next_keyframe || next_keyframe.time > kf.time)) next_keyframe = kf;\n\t\t\t\t\t\t})\n\t\t\t\t\t\tif (prvs_keyframe) dragging_restriction[0] = prvs_keyframe.time;\n\t\t\t\t\t\tif (next_keyframe) dragging_restriction[1] = next_keyframe.time;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tis_setup = true;\n\t\t\t}\n\n\t\t\tfunction slide(e2) {\n\t\t\t\tconvertTouchEvent(e2);\n\t\t\t\te2.preventDefault();\n\t\t\t\tlet offset = [\n\t\t\t\t\te2.clientX - e1.clientX,\n\t\t\t\t\te2.clientY - e1.clientY,\n\t\t\t\t]\n\t\t\t\tif (!is_setup) {\n\t\t\t\t\tif (Math.pow(offset[0], 2) + Math.pow(offset[1], 2) > 40) {\n\t\t\t\t\t\tsetup();\n\t\t\t\t\t} else {\n\t\t\t\t\t\treturn;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t// Time\n\t\t\t\tlet difference = 0;\n\t\t\t\tlet max, min;\n\t\t\t\tlet time_factor = 1;\n\t\t\t\tif ((!e2.ctrlOrCmd && !e2.shiftKey) || time_stretching || !Timeline.vue.graph_editor_open) {\n\t\t\t\t\tdifference = Math.clamp(offset[0] / Timeline.vue._data.size, -256, 256);\n\t\t\t\t\t[min, max] = dragging_range;\n\t\t\t\t\t\n\t\t\t\t\tif (time_stretching) {\n\t\t\t\t\t\ttime_factor = (clicked && clicked.time_before < (min + max) / 2)\n\t\t\t\t\t\t\t? ((max-min-difference) / (max-min))\n\t\t\t\t\t\t\t: ((max-min+difference) / (max-min));\n\t\t\t\t\t\ttime_factor = Math.roundTo(time_factor, 2);\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t// Value\n\t\t\t\tlet value = 0;\n\t\t\t\tlet value_diff = 0;\n\t\t\t\tif (Timeline.vue.graph_editor_open) {\n\t\t\t\t\tvalue = -offset[1] / Timeline.vue.graph_size;\n\t\t\t\t\tvar round_num = canvasGridSize(e2.shiftKey || Pressing.overrides.shift, e2.ctrlOrCmd || Pressing.overrides.ctrl);\n\t\t\t\t\tif (Toolbox.selected.id === 'resize_tool') {\n\t\t\t\t\t\tround_num *= 0.1;\n\t\t\t\t\t}\n\t\t\t\t\tvalue = Math.round(value/round_num)*round_num\n\t\t\t\t\tpreviousValue = previousValue == undefined ? value : previousValue;\n\t\t\t\t\toriginalValue = originalValue == undefined ? value : originalValue;\n\n\t\t\t\t\tif (value !== previousValue) {\n\t\t\t\t\t\tvalue_diff = value - (previousValue||0);\n\t\t\t\t\t\tpreviousValue = value;\n\t\t\t\t\t}\n\t\t\t\t}\t\n\t\t\t\tfor (let kf of Timeline.selected) {\n\t\t\t\t\tif (time_stretching) {\n\t\t\t\t\t\tif (clicked && clicked.time_before < (min + max) / 2) {\n\t\t\t\t\t\t\tvar t = max - (kf.time_before - max) * -time_factor;\n\t\t\t\t\t\t} else {\n\t\t\t\t\t\t\tvar t = min + (kf.time_before - min) * time_factor;\n\t\t\t\t\t\t}\n\t\t\t\t\t} else {\n\t\t\t\t\t\tvar t = kf.time_before + difference;\n\t\t\t\t\t}\n\t\t\t\t\tlet old_time = kf.time;\n\t\t\t\t\tif (dragging_restriction) {\n\t\t\t\t\t\tlet step = Timeline.getStep();\n\t\t\t\t\t\tkf.time = Timeline.snapTime(Math.clamp(t, dragging_restriction[0] + step, dragging_restriction[1] - step));\n\t\t\t\t\t} else {\n\t\t\t\t\t\tkf.time = Timeline.snapTime(t);\n\t\t\t\t\t}\n\t\t\t\t\tif (old_time !== kf.time) {\n\t\t\t\t\t\tvalues_changed = true;\n\t\t\t\t\t}\n\t\t\t\t\tif (time_stretching && kf.interpolation == 'bezier') {\n\t\t\t\t\t\tlet old_bezier = old_bezier_values[kf.uuid];\n\t\t\t\t\t\tkf.bezier_left_time.V3_set(old_bezier.left).V3_multiply(time_factor);\n\t\t\t\t\t\tkf.bezier_right_time.V3_set(old_bezier.right).V3_multiply(time_factor);\n\t\t\t\t\t}\n\n\t\t\t\t\tif (Timeline.vue.graph_editor_open && value_diff) {\n\t\t\t\t\t\tkf.offset(Timeline.vue.graph_editor_axis, value_diff);\n\t\t\t\t\t\tvalues_changed = true;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tif (time_stretching) {\n\t\t\t\t\tBlockbench.setStatusBarText(Math.round(time_factor * 100) + '%');\n\t\t\t\t} else {\n\t\t\t\t\tlet text = trimFloatNumber(Math.round(difference * Animation.selected.snapping));\n\t\t\t\t\tif (Timeline.vue.graph_editor_open) {\n\t\t\t\t\t\ttext += ` ⨉ ${trimFloatNumber(value - originalValue)}`\n\t\t\t\t\t}\n\t\t\t\t\tBlockbench.setStatusBarText(text);\n\t\t\t\t}\n\t\t\t\tBarItems.slider_keyframe_time.update()\n\t\t\t\tAnimator.showMotionTrail(null, true)\n\t\t\t\tAnimator.preview()\n\t\t\t\tTimeline.vue.refreshTimelineCanvas();\n\n\t\t\t}\n\t\t\tfunction off() {\n\t\t\t\tremoveEventListeners(document, 'mousemove touchmove', slide);\n\t\t\t\tremoveEventListeners(document, 'mouseup touchend', off);\n\n\t\t\t\tif (is_setup) {\n\t\t\t\t\tvar deleted = []\n\t\t\t\t\tfor (var kf of Timeline.selected) {\n\t\t\t\t\t\tdelete kf.time_before;\n\t\t\t\t\t\tkf.replaceOthers(deleted);\n\t\t\t\t\t}\n\t\t\t\t\tBlockbench.setStatusBarText();\n\t\t\t\t\tif (values_changed) {\n\t\t\t\t\t\tAnimation.selected.setLength();\n\t\t\t\t\t\tif (time_stretching) {\n\t\t\t\t\t\t\tUndo.finishEdit('Stretch keyframes');\n\t\t\t\t\t\t} else {\n\t\t\t\t\t\t\tUndo.addKeyframeCasualties(deleted);\n\t\t\t\t\t\t\tUndo.finishEdit('Drag keyframes');\n\t\t\t\t\t\t}\n\t\t\t\t\t} else {\n\t\t\t\t\t\tUndo.cancelEdit();\n\t\t\t\t\t}\n\t\t\t\t\tsetTimeout(() => {\n\t\t\t\t\t\tTimeline.dragging_keyframes = false;\n\t\t\t\t\t}, 20);\n\n\t\t\t\t\tTimeline.vue.refreshTimelineCanvas();\n\t\t\t\t}\n\t\t\t}\n\t\t\taddEventListeners(document, 'mousemove touchmove', slide, {passive: false});\n\t\t\taddEventListeners(document, 'mouseup touchend', off);\n\t\t},\n\t\tdragBezierHandle(clicked, side, e1) {\n\t\t\tif (e1.button > 0) return;\n\t\t\tconvertTouchEvent(e1);\n\t\t\tlet values_changed;\n\t\t\tlet is_setup = false;\n\t\t\tlet axis_number = getAxisNumber(this.graph_editor_axis);\n\t\t\tlet old_values = {};\n\t\t\tlet lock_direction;\n\n\t\t\tfunction setup(offset) {\n\n\t\t\t\tif (!clicked.selected && !e1.shiftKey && !Pressing.overrides.shift && Timeline.selected.length != 0) {\n\t\t\t\t\tclicked.select()\n\t\t\t\t} else if (clicked && !clicked.selected) {\n\t\t\t\t\tclicked.select({shiftKey: true})\n\t\t\t\t}\n\t\t\t\tlock_direction = Math.abs(offset[0]) > Math.abs(offset[1]);\n\n\t\t\t\tKeyframe.selected.forEach(kf => {\n\t\t\t\t\tif (kf.interpolation == 'bezier') {\n\t\t\t\t\t\told_values[kf.uuid] = {\n\t\t\t\t\t\t\tbezier_left_time: kf.bezier_left_time.slice(),\n\t\t\t\t\t\t\tbezier_left_value: kf.bezier_left_value.slice(),\n\t\t\t\t\t\t\tbezier_right_time: kf.bezier_right_time.slice(),\n\t\t\t\t\t\t\tbezier_right_value: kf.bezier_right_value.slice(),\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t})\n\n\t\t\t\tUndo.initEdit({keyframes: Timeline.selected});\n\t\t\t\tTimeline.dragging_keyframes = true;\n\n\t\t\t\tis_setup = true;\n\t\t\t}\n\n\t\t\tfunction slide(e2) {\n\t\t\t\tconvertTouchEvent(e2);\n\t\t\t\te2.preventDefault();\n\t\t\t\tlet offset = [\n\t\t\t\t\te2.clientX - e1.clientX,\n\t\t\t\t\te2.clientY - e1.clientY,\n\t\t\t\t]\n\t\t\t\tif (!is_setup) {\n\t\t\t\t\tif (Math.pow(offset[0], 2) + Math.pow(offset[1], 2) > 20) {\n\t\t\t\t\t\tsetup(offset);\n\t\t\t\t\t} else {\n\t\t\t\t\t\treturn;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tlet difference_time = Math.clamp(offset[0] / Timeline.vue._data.size, -256, 256);\n\t\t\t\tlet difference_value = Math.clamp(-offset[1] / Timeline.vue.graph_size, -256, 256);\n\t\t\t\tif (e2.shiftKey || Pressing.overrides.shift) {\n\t\t\t\t\tif (lock_direction) {\n\t\t\t\t\t\tdifference_value = 0;\n\t\t\t\t\t} else {\n\t\t\t\t\t\tdifference_time = 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tif (e2.ctrlOrCmd || Pressing.overrides.ctrl) {\n\t\t\t\t\tlet time_snap = Timeline.getStep();\n\t\t\t\t\tlet val_snap = 0.25;\n\t\t\t\t\tdifference_time = Math.round(difference_time / time_snap) * time_snap;\n\t\t\t\t\tdifference_value = Math.round(difference_value / val_snap) * val_snap;\n\t\t\t\t}\n\n\t\t\t\tfor (let kf of Timeline.selected) {\n\t\t\t\t\tif (kf.interpolation == 'bezier') {\n\n\t\t\t\t\t\tkf.bezier_left_time.V3_set(old_values[kf.uuid].bezier_left_time);\n\t\t\t\t\t\tkf.bezier_left_value.V3_set(old_values[kf.uuid].bezier_left_value);\n\t\t\t\t\t\tkf.bezier_right_time.V3_set(old_values[kf.uuid].bezier_right_time);\n\t\t\t\t\t\tkf.bezier_right_value.V3_set(old_values[kf.uuid].bezier_right_value);\n\n\t\t\t\t\t\tif (side === 'left') {\n\t\t\t\t\t\t\tkf.bezier_left_time[axis_number] =  Math.min(0, old_values[kf.uuid].bezier_left_time[axis_number] + difference_time);\n\t\t\t\t\t\t\tkf.bezier_left_value[axis_number] = old_values[kf.uuid].bezier_left_value[axis_number] + difference_value;\n\t\t\t\t\t\t\tif (kf.bezier_linked) {\n\t\t\t\t\t\t\t\tkf.bezier_right_time[axis_number] = -kf.bezier_left_time[axis_number];\n\t\t\t\t\t\t\t\tkf.bezier_right_value[axis_number] = -kf.bezier_left_value[axis_number];\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\tif (side === 'right') {\n\t\t\t\t\t\t\tkf.bezier_right_time[axis_number] =  Math.max(0, old_values[kf.uuid].bezier_right_time[axis_number] + difference_time);\n\t\t\t\t\t\t\tkf.bezier_right_value[axis_number] = old_values[kf.uuid].bezier_right_value[axis_number] + difference_value;\n\t\t\t\t\t\t\tif (kf.bezier_linked) {\n\t\t\t\t\t\t\t\tkf.bezier_left_time[axis_number] = -kf.bezier_right_time[axis_number];\n\t\t\t\t\t\t\t\tkf.bezier_left_value[axis_number] = -kf.bezier_right_value[axis_number];\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\tif (kf.uniform) {\n\t\t\t\t\t\t\tlet off_axis_a = (axis_number+1) % 3;\n\t\t\t\t\t\t\tlet off_axis_b = (axis_number+2) % 3;\n\t\t\t\t\t\t\tkf.bezier_right_time[off_axis_a] = kf.bezier_right_time[off_axis_b] = kf.bezier_right_time[axis_number];\n\t\t\t\t\t\t\tkf.bezier_right_value[off_axis_a] = kf.bezier_right_value[off_axis_b] = kf.bezier_right_value[axis_number];\n\t\t\t\t\t\t\tkf.bezier_left_time[off_axis_a] = kf.bezier_left_time[off_axis_b] = kf.bezier_left_time[axis_number];\n\t\t\t\t\t\t\tkf.bezier_left_value[off_axis_a] = kf.bezier_left_value[off_axis_b] = kf.bezier_left_value[axis_number];\n\t\t\t\t\t\t}\n\t\t\t\t\t\tvalues_changed = true;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tlet text = `${trimFloatNumber(Math.roundTo(difference_time, 2))} ⨉ ${trimFloatNumber(Math.roundTo(difference_value, 2))}`;\n\t\t\t\tBlockbench.setStatusBarText(text);\n\n\t\t\t\tTimeline.vue.show_zero_line = !Timeline.vue.show_zero_line;\n\t\t\t\tTimeline.vue.show_zero_line = !Timeline.vue.show_zero_line;\n\t\t\t\tAnimator.showMotionTrail(null, true)\n\t\t\t\tAnimator.preview()\n\t\t\t\tTimeline.vue.refreshTimelineCanvas();\n\t\t\t}\n\t\t\tfunction off() {\n\t\t\t\tremoveEventListeners(document, 'mousemove touchmove', slide);\n\t\t\t\tremoveEventListeners(document, 'mouseup touchend', off);\n\n\t\t\t\tif (is_setup) {\n\t\t\t\t\tBlockbench.setStatusBarText();\n\t\t\t\t\tif (values_changed) {\n\t\t\t\t\t\tUndo.finishEdit('Adjust keyframe bezier handles');\n\t\t\t\t\t} else {\n\t\t\t\t\t\tUndo.cancelEdit();\n\t\t\t\t\t}\n\t\t\t\t\tsetTimeout(() => {\n\t\t\t\t\t\tTimeline.dragging_keyframes = false;\n\t\t\t\t\t}, 20);\n\t\t\t\t}\n\t\t\t}\n\t\t\taddEventListeners(document, 'mousemove touchmove', slide, {passive: false});\n\t\t\taddEventListeners(document, 'mouseup touchend', off);\n\t\t},\n\t\tslideGraphAmplify(e1, anchor_side) {\n\t\t\tif (e1.button > 0) return;\n\t\t\tconvertTouchEvent(e1);\n\t\t\tlet original_values = {};\n\t\t\tlet values_changed;\n\t\t\tlet is_setup = false;\n\t\t\tlet keyframes = this.graph_editor_animator[this.graph_editor_channel].filter(kf => kf.selected);\n\t\t\tlet original_range = this.getSelectedGraphRange();\n\t\t\tlet original_pixel_range = (original_range[1] - original_range[0]) * this.graph_size;\n\t\t\tlet axis = this.graph_editor_axis;\n\n\t\t\tfunction setup() {\n\t\t\t\tUndo.initEdit({keyframes});\n\t\t\t\tvalues_changed = false;\n\t\t\t\tTimeline.dragging_keyframes = true;\n\t\t\t\tis_setup = true;\n\n\t\t\t\tfor (let kf of keyframes) {\n\t\t\t\t\toriginal_values[kf.uuid] = kf.display_value || kf.get(axis);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\tfunction slide(e2) {\n\t\t\t\tconvertTouchEvent(e2);\n\t\t\t\te2.preventDefault();\n\t\t\t\tlet offset = e2.clientY - e1.clientY;\n\t\t\t\tif (anchor_side == 1) offset *= -1;\n\t\t\t\tif (!is_setup) {\n\t\t\t\t\tif (Math.abs(offset) > 4) {\n\t\t\t\t\t\tsetup();\n\t\t\t\t\t} else {\n\t\t\t\t\t\treturn;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\tlet value = 1 - offset / original_pixel_range;\n\t\t\t\tvalue = Math.round(value*100)/100;\n\n\t\t\t\tfor (let kf of keyframes) {\n\t\t\t\t\tlet origin = original_range[anchor_side];\n\t\t\t\t\tif (e2.altKey) {\n\t\t\t\t\t\torigin = Math.lerp(original_range[0], original_range[1], 0.5);\n\t\t\t\t\t}\n\t\t\t\t\tlet target_value = (original_values[kf.uuid] - origin) * value + origin;\n\t\t\t\t\tkf.offset(axis, -kf.get(axis) + target_value);\n\t\t\t\t\tvalues_changed = true;\n\t\t\t\t}\n\t\t\t\tlet text = Math.round(value * 100) + '%';\n\t\t\t\tBlockbench.setStatusBarText(text);\n\t\t\t\tAnimator.showMotionTrail(null, true)\n\t\t\t\tAnimator.preview()\n\t\t\t\tTimeline.vue.refreshTimelineCanvas();\n\t\t\t}\n\t\t\tfunction off() {\n\t\t\t\tremoveEventListeners(document, 'mousemove touchmove', slide);\n\t\t\t\tremoveEventListeners(document, 'mouseup touchend', off);\n\n\t\t\t\tif (is_setup) {\n\t\t\t\t\tBlockbench.setStatusBarText();\n\t\t\t\t\tif (values_changed) {\n\t\t\t\t\t\tUndo.finishEdit('Amplify keyframes');\n\t\t\t\t\t} else {\n\t\t\t\t\t\tUndo.cancelEdit();\n\t\t\t\t\t}\n\t\t\t\t\tsetTimeout(() => {\n\t\t\t\t\t\tTimeline.dragging_keyframes = false;\n\t\t\t\t\t}, 20);\n\t\t\t\t}\n\t\t\t}\n\t\t\taddEventListeners(document, 'mousemove touchmove', slide, {passive: false});\n\t\t\taddEventListeners(document, 'mouseup touchend', off);\n\t\t},\n\t\tclickGraphEditor(event) {\n\t\t\tif (!this.show_other_graphs || !this.graph_editor_animator) return;\n\t\t\tlet value = (this.graph_offset - event.offsetY) / this.graph_size;\n\t\t\tlet original_time = Timeline.time;\n\n\t\t\tlet tryAt = (x_coord) => {\n\t\t\t\tlet time = (x_coord) / this.size;\n\t\t\t\tTimeline.time = time;\n\n\t\t\t\tlet distances = ['x', 'y', 'z'].map(axis => {\n\t\t\t\t\tlet axis_value = this.graph_editor_animator.interpolate(this.graph_editor_channel, false, axis);\n\t\t\t\t\tlet diff = Math.abs(axis_value - value) * this.graph_size;\n\t\t\t\t\tif (diff < 12.5) {\n\t\t\t\t\t\treturn {axis, diff};\n\t\t\t\t\t}\n\t\t\t\t}).filter(a => a);\n\t\t\t\tif (distances.length) return distances;\n\t\t\t}\n\t\t\t\n\t\t\tlet real_x_coord = event.offsetX-8;\n\t\t\tlet distances = tryAt(real_x_coord) || tryAt(real_x_coord + 4) || tryAt(real_x_coord - 4);\n\n\t\t\tif (distances) {\n\t\t\t\tdistances.sort((a, b) => a.diff - b.diff);\n\t\t\t\tthis.graph_editor_axis = distances[0].axis;\n\t\t\t}\n\t\t\tTimeline.time = original_time;\n\t\t},\n\t\tgetBezierHandleStyle(keyframe, side) {\n\t\t\tlet axis_number = getAxisNumber(this.graph_editor_axis);\n\t\t\tlet x_offset = -keyframe[`bezier_${side}_time`][axis_number] * this.size;\n\t\t\tlet y_offset = -keyframe[`bezier_${side}_value`][axis_number] * this.graph_size;\n\t\t\tlet length = Math.sqrt(Math.pow(x_offset, 2) + Math.pow(y_offset, 2));\n\t\t\tlet angle = Math.atan2(-y_offset, x_offset);\n\t\t\treturn {\n\t\t\t\tright: x_offset + 'px',\n\t\t\t\ttop: y_offset + 'px',\n\t\t\t\t'--length': Math.max(length - 6, 0) + 'px',\n\t\t\t\t'--angle': Math.radToDeg(angle) + 'deg',\n\t\t\t}\n\t\t},\n\t\tgetSelectedGraphRange() {\n\t\t\tif (Keyframe.selected.length == 0 || !this.graph_editor_animator) return null;\n\t\t\tlet keyframes = this.graph_editor_animator[this.graph_editor_channel];\n\t\t\tif (!keyframes || keyframes.length < 2) return null;\n\t\t\tlet range = [Infinity, -Infinity];\n\t\t\tkeyframes.forEach(kf => {\n\t\t\t\tif (!kf.selected) return;\n\t\t\t\trange[0] = Math.min(range[0], kf.display_value);\n\t\t\t\trange[1] = Math.max(range[1], kf.display_value);\n\t\t\t})\n\t\t\tif (range[0] == range[1]) return null;\n\t\t\treturn range;\n\t\t},\n\t\tgetNodeColor(node) {\n\t\t\tif (node.color >= 0) {\n\t\t\t\treturn markerColors[node.color % markerColors.length].pastel;\n\t\t\t}\n\t\t\treturn '';\n\t\t},\n\t\tclamp: Math.clamp,\n\t\tCondition,\n\t\ttrimFloatNumber,\n\t\tgetAxisLetter\n\t}\n}\n</script>\n\n<style>\n#timeline_body_inner {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: flex-start;\n    align-items: flex-start;\n}\n\n#timeline_body_channel_headers {\n\tdisplay: flex;\n\tflex-direction: column;\n    position: sticky;\n    left: 0px;\n    z-index: 4;\n    min-height: stretch;\n}\n\n#timeline_body_keyframe_canvas {\n    position: sticky;\n\ttop: 0;\n    z-index: 2;\n}\n\n#timeline_body_keyframe_backdrop {\n    position: sticky;\n\ttop: 0;\n    z-index: 0;\n\twidth: stretch;\n\theight: stretch;\n}\n\n.keyframe.graph_keyframe > svg {\n\tmargin: none;\n\tpointer-events: inherit;\n}\n\n.animator_channel_bar {\n\toverflow: clip;\n}\n</style>"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "js/animations/Timeline.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__